export enum DfwCities {
  Abbott = 'abbott',
  Abernat = 'abernat',
  Abilene = 'abilene',
  Achille = 'achille',
  Ackerly = 'ackerly',
  Acton = 'acton',
  Ada = 'ada',
  Adamsville = 'adamsville',
  Addison = 'addison',
  Adkins = 'adkins',
  Adrian = 'adrian',
  Agen = 'agen',
  AguaDulce = 'aguaDulce',
  Ahloso = 'ahloso',
  AixEnProvence = 'aixEnProvence',
  Alamo = 'alamo',
  AlamoHeights = 'alamoHeights',
  Alamogordo = 'alamogordo',
  Alba = 'alba',
  Albany = 'albany',
  Aledo = 'aledo',
  Alexander = 'alexander',
  Algoa = 'algoa',
  Alicante = 'alicante',
  Alice = 'alice',
  Allen = 'allen',
  Allison = 'allison',
  Alma = 'alma',
  Alpine = 'alpine',
  Alto = 'alto',
  Alton = 'alton',
  Alvarado = 'alvarado',
  Alvin = 'alvin',
  Alvord = 'alvord',
  Amarillo = 'amarillo',
  Ambrose = 'ambrose',
  Ames = 'ames',
  Amherst = 'amherst',
  Anahuac = 'anahuac',
  Anderson = 'anderson',
  Andrews = 'andrews',
  AngelFire = 'angelFire',
  Angeot = 'angeot',
  Angleton = 'angleton',
  Anguilla = 'anguilla',
  Angus = 'angus',
  Anna = 'anna',
  AnnaMaria = 'annaMaria',
  Annetta = 'annetta',
  AnnettaNorth = 'annettaNorth',
  AnnettaSouth = 'annettaSouth',
  Annona = 'annona',
  Anson = 'anson',
  Anthony = 'anthony',
  Antibes = 'antibes',
  AntiguoCuscaltan = 'antiguoCuscaltan',
  Anton = 'anton',
  Appleby = 'appleby',
  Aquilla = 'aquilla',
  AransasPass = 'aransasPass',
  ArcherCity = 'archerCity',
  Arcola = 'arcola',
  Ardmore = 'ardmore',
  Arecibo = 'arecibo',
  Argyle = 'argyle',
  Arkoma = 'arkoma',
  Arles = 'arles',
  Arlington = 'arlington',
  Armstrong = 'armstrong',
  Arp = 'arp',
  ArthurCity = 'arthurCity',
  Asheville = 'asheville',
  Ashland = 'ashland',
  Aspermont = 'aspermont',
  Atascosa = 'atascosa',
  Athens = 'athens',
  Atlanta = 'atlanta',
  Atoka = 'atoka',
  Aubrey = 'aubrey',
  Aurora = 'aurora',
  Austin = 'austin',
  Austwell = 'austwell',
  AvaillessurSeiche = 'availlessurSeiche',
  Avalon = 'avalon',
  Avant = 'avant',
  Avery = 'avery',
  Avignon = 'avignon',
  Avilla = 'avilla',
  Avinger = 'avinger',
  Axtell = 'axtell',
  Azle = 'azle',
  Bagnols = 'bagnols',
  Bagwell = 'bagwell',
  Bailey = 'bailey',
  BaileysPrairie = 'baileysPrairie',
  Baird = 'baird',
  BalchSprings = 'balchSprings',
  BalconesHeights = 'balconesHeights',
  Balfour = 'balfour',
  Bali = 'bali',
  Ballinger = 'ballinger',
  Balmorhea = 'balmorhea',
  Bandera = 'bandera',
  Bangs = 'bangs',
  Banquete = 'banquete',
  Barcelona = 'barcelona',
  Bardwell = 'bardwell',
  Barling = 'barling',
  Barry = 'barry',
  Barstow = 'barstow',
  Bartlett = 'bartlett',
  Bartonville = 'bartonville',
  Bastrop = 'bastrop',
  Batonrouge = 'batonrouge',
  Battiest = 'battiest',
  Bauxite = 'bauxite',
  Bay = 'bay',
  BayCity = 'bayCity',
  BayouVista = 'bayouVista',
  Bayside = 'bayside',
  Baytown = 'baytown',
  Beach = 'beach',
  Bear = 'bear',
  BearCreek = 'bearCreek',
  Beasley = 'beasley',
  Beaumont = 'beaumont',
  Beckville = 'beckville',
  Bedford = 'bedford',
  Bee = 'bee',
  BeeCave = 'beeCave',
  Beeville = 'beeville',
  Belfalls = 'belfalls',
  Belgrade = 'belgrade',
  Belize = 'belize',
  BellaVista = 'bellaVista',
  Bellaire = 'bellaire',
  Bellevue = 'bellevue',
  Bellmead = 'bellmead',
  Bells = 'bells',
  Bellville = 'bellville',
  Belton = 'belton',
  BenFranklin = 'benFranklin',
  BenWheeler = 'benWheeler',
  Benavides = 'benavides',
  Benbrook = 'benbrook',
  Benchley = 'benchley',
  Bend = 'bend',
  Benjamin = 'benjamin',
  Bennington = 'bennington',
  Benton = 'benton',
  Bentonville = 'bentonville',
  Berea = 'berea',
  Berlin = 'berlin',
  Berryville = 'berryville',
  Bertram = 'bertram',
  Bethel = 'bethel',
  BethelHeights = 'bethelHeights',
  BeverlyHills = 'beverlyHills',
  BevilOaks = 'bevilOaks',
  Beziers = 'beziers',
  BigLake = 'bigLake',
  BigSandy = 'bigSandy',
  BigSpring = 'bigSpring',
  Birome = 'birome',
  Birthright = 'birthright',
  Bishop = 'bishop',
  BishopHills = 'bishopHills',
  Bismarck = 'bismarck',
  Bivins = 'bivins',
  Blacksburg = 'blacksburg',
  Blackwell = 'blackwell',
  Blainville = 'blainville',
  Blakely = 'blakely',
  Blanco = 'blanco',
  Bland = 'bland',
  Blanket = 'blanket',
  Blessing = 'blessing',
  Bloomburg = 'bloomburg',
  BloomingGrove = 'bloomingGrove',
  Blossom = 'blossom',
  Blue = 'blue',
  BlueMound = 'blueMound',
  BlueRidge = 'blueRidge',
  BlueSprings = 'blueSprings',
  Bluegrove = 'bluegrove',
  BluffDale = 'bluffDale',
  Bluffton = 'bluffton',
  Blum = 'blum',
  Blythe = 'blythe',
  Boerne = 'boerne',
  Bogata = 'bogata',
  Bokchito = 'bokchito',
  Bokhoma = 'bokhoma',
  Bolivar = 'bolivar',
  Bonham = 'bonham',
  BonitaSprings = 'bonitaSprings',
  Bonnerdale = 'bonnerdale',
  Bonney = 'bonney',
  Booker = 'booker',
  Booneville = 'booneville',
  Boonsville = 'boonsville',
  Bordeaux = 'bordeaux',
  Boswell = 'boswell',
  Bovina = 'bovina',
  Bowie = 'bowie',
  Boyce = 'boyce',
  Boyd = 'boyd',
  Bozeman = 'bozeman',
  Brackettville = 'brackettville',
  Brad = 'brad',
  Bradshaw = 'bradshaw',
  Brady = 'brady',
  Branch = 'branch',
  Brandon = 'brandon',
  Brashear = 'brashear',
  Brazoria = 'brazoria',
  Brazos = 'brazos',
  Breckenridge = 'breckenridge',
  Bremond = 'bremond',
  Brenham = 'brenham',
  Briarcliff = 'briarcliff',
  Briaroaks = 'briaroaks',
  Bridge = 'bridge',
  Bridgeport = 'bridgeport',
  Briggs = 'briggs',
  Briscoe = 'briscoe',
  Bristol = 'bristol',
  Broaddus = 'broaddus',
  Brock = 'brock',
  BrokenBow = 'brokenBow',
  Bromide = 'bromide',
  Bronte = 'bronte',
  Brookesmith = 'brookesmith',
  Brookshire = 'brookshire',
  Brookside = 'brookside',
  Brookston = 'brookston',
  Browndell = 'browndell',
  Brownfield = 'brownfield',
  Brownsboro = 'brownsboro',
  Brownsville = 'brownsville',
  Brownwood = 'brownwood',
  BrucevilleEddy = 'brucevilleEddy',
  Brunswick = 'brunswick',
  Bryan = 'bryan',
  Bryant = 'bryant',
  Bryson = 'bryson',
  BuchananDam = 'buchananDam',
  Buckholts = 'buckholts',
  Buckingham = 'buckingham',
  Buda = 'buda',
  Buffalo = 'buffalo',
  BuffaloGap = 'buffaloGap',
  BugTusle = 'bugTusle',
  BullShoals = 'bullShoals',
  Bullard = 'bullard',
  Bulverde = 'bulverde',
  Buna = 'buna',
  BunkerHillVillage = 'bunkerHillVillage',
  Bunyan = 'bunyan',
  Burkburnett = 'burkburnett',
  Burke = 'burke',
  Burkett = 'burkett',
  Burkeville = 'burkeville',
  Burleson = 'burleson',
  Burlington = 'burlington',
  Burnet = 'burnet',
  Burneyville = 'burneyville',
  BurnsFlat = 'burnsFlat',
  Burton = 'burton',
  Butterfield = 'butterfield',
  Byers = 'byers',
  Byng = 'byng',
  Bynum = 'bynum',
  Cabarete = 'cabarete',
  CaboSanLucas = 'caboSanLucas',
  Cactus = 'cactus',
  Caddo = 'caddo',
  CaddoMills = 'caddoMills',
  Caen = 'caen',
  Caldwell = 'caldwell',
  Calera = 'calera',
  Callisburg = 'callisburg',
  Caloocan = 'caloocan',
  Calvert = 'calvert',
  Cameron = 'cameron',
  CampWood = 'campWood',
  Campbell = 'campbell',
  Canadian = 'canadian',
  Cancun = 'cancun',
  Caney = 'caney',
  CaneyCity = 'caneyCity',
  Cannes = 'cannes',
  CanonCity = 'canonCity',
  Canton = 'canton',
  Canutillo = 'canutillo',
  Canyon = 'canyon',
  CanyonLake = 'canyonLake',
  Capitola = 'capitola',
  CappsCorner = 'cappsCorner',
  Caradan = 'caradan',
  Carbon = 'carbon',
  CarlsCorner = 'carlsCorner',
  Carlsbad = 'carlsbad',
  Carlton = 'carlton',
  Carmel = 'carmel',
  Carmine = 'carmine',
  CarolinaBeach = 'carolinaBeach',
  Carpenter = 'carpenter',
  Carrabelle = 'carrabelle',
  Carrollton = 'carrollton',
  Carson = 'carson',
  Cartago = 'cartago',
  Carthage = 'carthage',
  Cartwright = 'cartwright',
  Cash = 'cash',
  Cason = 'cason',
  Castell = 'castell',
  CastiglionFiorentino = 'castiglionFiorentino',
  CastleHills = 'castleHills',
  Castries = 'castries',
  Castroville = 'castroville',
  CaveSprings = 'caveSprings',
  Cayuga = 'cayuga',
  CebuCity = 'cebuCity',
  CedarCreek = 'cedarCreek',
  CedarCreekLake = 'cedarCreekLake',
  CedarHill = 'cedarHill',
  CedarLane = 'cedarLane',
  CedarPark = 'cedarPark',
  Celeste = 'celeste',
  Celina = 'celina',
  Celles = 'celles',
  Center = 'center',
  CenterCity = 'centerCity',
  Centerton = 'centerton',
  Centerville = 'centerville',
  CentralCity = 'centralCity',
  ChacteauneufduPape = 'chacteauneufduPape',
  Chandler = 'chandler',
  Channing = 'channing',
  ChapmanRanch = 'chapmanRanch',
  ChappellHill = 'chappellHill',
  Charleston = 'charleston',
  Charlotte = 'charlotte',
  Chatfield = 'chatfield',
  Chatham = 'chatham',
  Cheney = 'cheney',
  Cherokee = 'cherokee',
  Chester = 'chester',
  Chetumal = 'chetumal',
  Cheyenne = 'cheyenne',
  Chicago = 'chicago',
  Chico = 'chico',
  Chicota = 'chicota',
  Childress = 'childress',
  Chillicothe = 'chillicothe',
  Chilton = 'chilton',
  China = 'china',
  ChinaGrove = 'chinaGrove',
  ChinaSpring = 'chinaSpring',
  Chinandega = 'chinandega',
  Chireno = 'chireno',
  Chriesman = 'chriesman',
  Christiansburg = 'christiansburg',
  Christine = 'christine',
  Christoval = 'christoval',
  Cibolo = 'cibolo',
  Cisco = 'cisco',
  Clairette = 'clairette',
  Clarendon = 'clarendon',
  Clark = 'clark',
  Clarksville = 'clarksville',
  Claude = 'claude',
  Clay = 'clay',
  Clayton = 'clayton',
  ClearLakeShores = 'clearLakeShores',
  Clearwater = 'clearwater',
  Cleburne = 'cleburne',
  Cleveland = 'cleveland',
  Clifton = 'clifton',
  Clint = 'clint',
  Clinton = 'clinton',
  Clute = 'clute',
  Clyde = 'clyde',
  Coahoma = 'coahoma',
  CockrellHill = 'cockrellHill',
  Coffee = 'coffee',
  CoffeeCity = 'coffeeCity',
  Cojutepeque = 'cojutepeque',
  Colbert = 'colbert',
  ColdSpring = 'coldSpring',
  Coldspring = 'coldspring',
  Coleman = 'coleman',
  CollegeStation = 'collegeStation',
  Collegeport = 'collegeport',
  Colleyville = 'colleyville',
  Collinsville = 'collinsville',
  Colmesneil = 'colmesneil',
  Colorado = 'colorado',
  ColoradoCity = 'coloradoCity',
  Columbus = 'columbus',
  Comanche = 'comanche',
  Combes = 'combes',
  Combine = 'combine',
  Comfort = 'comfort',
  Commerce = 'commerce',
  Como = 'como',
  Concord = 'concord',
  Congo = 'congo',
  Connerville = 'connerville',
  Conroe = 'conroe',
  Converse = 'converse',
  Conway = 'conway',
  Cookville = 'cookville',
  Cool = 'cool',
  Coolidge = 'coolidge',
  Cooper = 'cooper',
  Copeville = 'copeville',
  Coppell = 'coppell',
  CopperCanyon = 'copperCanyon',
  CopperasCove = 'copperasCove',
  Cordell = 'cordell',
  Corinth = 'corinth',
  Corozal = 'corozal',
  CorpusChristi = 'corpusChristi',
  CorralCity = 'corralCity',
  Corrigan = 'corrigan',
  Corsicana = 'corsicana',
  Cortona = 'cortona',
  CostadelEste = 'costadelEste',
  CostaRica = 'costaRica',
  Cotter = 'cotter',
  CottonCenter = 'cottonCenter',
  Cottonwood = 'cottonwood',
  CottonwoodShores = 'cottonwoodShores',
  Cotulla = 'cotulla',
  Coupland = 'coupland',
  Courtney = 'courtney',
  Cove = 'cove',
  Covington = 'covington',
  Crandall = 'crandall',
  Crane = 'crane',
  CranfillsGap = 'cranfillsGap',
  Crawford = 'crawford',
  Creedmoor = 'creedmoor',
  Cresson = 'cresson',
  CrestedButte = 'crestedButte',
  Crockett = 'crockett',
  Crosbyton = 'crosbyton',
  CrossCut = 'crossCut',
  CrossPlains = 'crossPlains',
  CrossRoads = 'crossRoads',
  CrossTimber = 'crossTimber',
  Crossville = 'crossville',
  Crowell = 'crowell',
  Crowley = 'crowley',
  Crows = 'crows',
  Crystal = 'crystal',
  CrystalBeach = 'crystalBeach',
  CrystalSprings = 'crystalSprings',
  Cuero = 'cuero',
  Cumby = 'cumby',
  Cuney = 'cuney',
  Cunningham = 'cunningham',
  Cushing = 'cushing',
  CutandShoot = 'cutandShoot',
  DHanis = 'dHanis',
  Daingerfield = 'daingerfield',
  Daisetta = 'daisetta',
  Dalhart = 'dalhart',
  Dallas = 'dallas',
  Dalton = 'dalton',
  DalworthingtonGardens = 'dalworthingtonGardens',
  Danbury = 'danbury',
  Danner = 'danner',
  Dardanelle = 'dardanelle',
  Darrouzett = 'darrouzett',
  Dawson = 'dawson',
  Dayton = 'dayton',
  DaytonLakes = 'daytonLakes',
  DeBerry = 'deBerry',
  DeCordova = 'deCordova',
  DeKalb = 'deKalb',
  DeLeon = 'deLeon',
  Dean = 'dean',
  Deanville = 'deanville',
  Decatur = 'decatur',
  DeerPark = 'deerPark',
  DelRio = 'delRio',
  DelValle = 'delValle',
  Dell = 'dell',
  Denison = 'denison',
  Dennis = 'dennis',
  Denton = 'denton',
  DENTONVALLEY = 'dENTONVALLEY',
  Denver = 'denver',
  Deport = 'deport',
  Derby = 'derby',
  DesArc = 'desArc',
  Desdemona = 'desdemona',
  DeSoto = 'deSoto',
  Detroit = 'detroit',
  Devers = 'devers',
  Devine = 'devine',
  Devol = 'devol',
  Dew = 'dew',
  DiamondHead = 'diamondHead',
  Diana = 'diana',
  Diboll = 'diboll',
  Dickens = 'dickens',
  Dickinson = 'dickinson',
  Dike = 'dike',
  DillCity = 'dillCity',
  Dilley = 'dilley',
  Dimmitt = 'dimmitt',
  Dinero = 'dinero',
  Dish = 'dish',
  Divide = 'divide',
  DoddCity = 'doddCity',
  Dodson = 'dodson',
  Domino = 'domino',
  Donie = 'donie',
  Donna = 'donna',
  Doole = 'doole',
  Dorchester = 'dorchester',
  Doss = 'doss',
  Dothan = 'dothan',
  DoubleOak = 'doubleOak',
  Douglass = 'douglass',
  Douglassville = 'douglassville',
  DoveCreek = 'doveCreek',
  Draguignan = 'draguignan',
  Driftwood = 'driftwood',
  DrippingSprings = 'drippingSprings',
  Driscoll = 'driscoll',
  Dublin = 'dublin',
  Dudley = 'dudley',
  Duffau = 'duffau',
  Dumas = 'dumas',
  Duncan = 'duncan',
  Duncanville = 'duncanville',
  Dunlap = 'dunlap',
  Dunn = 'dunn',
  Duplex = 'duplex',
  Durant = 'durant',
  Durban = 'durban',
  Durham = 'durham',
  EagleLake = 'eagleLake',
  EagleNest = 'eagleNest',
  EaglePass = 'eaglePass',
  Eagletown = 'eagletown',
  Eagltown = 'eagltown',
  Early = 'early',
  Earth = 'earth',
  EastEnd = 'eastEnd',
  EastMountain = 'eastMountain',
  EastTawakoni = 'eastTawakoni',
  Easterly = 'easterly',
  Eastland = 'eastland',
  Easton = 'easton',
  Ebony = 'ebony',
  Ecleto = 'ecleto',
  Ector = 'ector',
  Edcouch = 'edcouch',
  Eden = 'eden',
  EdgecliffVillage = 'edgecliffVillage',
  Edgewood = 'edgewood',
  Edinburg = 'edinburg',
  EdmonAlberta = 'edmonAlberta',
  Edmonson = 'edmonson',
  Edna = 'edna',
  Edom = 'edom',
  ElCampo = 'elCampo',
  ElCenizo = 'elCenizo',
  ElIndio = 'elIndio',
  ElLago = 'elLago',
  ElPaso = 'elPaso',
  ElVendrell = 'elVendrell',
  Eldorado = 'eldorado',
  Electra = 'electra',
  Eleuthera = 'eleuthera',
  Elgin = 'elgin',
  ElkCity = 'elkCity',
  Elkhart = 'elkhart',
  Elkins = 'elkins',
  Ellicott = 'ellicott',
  ElmGrove = 'elmGrove',
  ElmMott = 'elmMott',
  Elmaton = 'elmaton',
  Elmendorf = 'elmendorf',
  Elmo = 'elmo',
  Elsa = 'elsa',
  Elwood = 'elwood',
  ElysianFields = 'elysianFields',
  Emhouse = 'emhouse',
  Emory = 'emory',
  EnchantedOaks = 'enchantedOaks',
  Encinal = 'encinal',
  Energy = 'energy',
  Enet = 'enet',
  Enloe = 'enloe',
  Ennis = 'ennis',
  Era = 'era',
  Estancia = 'estancia',
  Estelline = 'estelline',
  Etoile = 'etoile',
  Eula = 'eula',
  Euless = 'euless',
  Eureka = 'eureka',
  Eustace = 'eustace',
  Evadale = 'evadale',
  Evansville = 'evansville',
  Evant = 'evant',
  Everman = 'everman',
  Evres = 'evres',
  Fabens = 'fabens',
  FairOaksRanch = 'fairOaksRanch',
  Fairchilds = 'fairchilds',
  Fairfield = 'fairfield',
  Fairlie = 'fairlie',
  Fairview = 'fairview',
  Fairy = 'fairy',
  Falcon = 'falcon',
  Falfurrias = 'falfurrias',
  Falls = 'falls',
  FarmersBranch = 'farmersBranch',
  Farmersville = 'farmersville',
  Farmington = 'farmington',
  Farwell = 'farwell',
  Fate = 'fate',
  Fayetteville = 'fayetteville',
  Felker = 'felker',
  Ferris = 'ferris',
  Filmore = 'filmore',
  Fischer = 'fischer',
  Fisk = 'fisk',
  Fittstown = 'fittstown',
  Fitzhugh = 'fitzhugh',
  Flat = 'flat',
  Flatonia = 'flatonia',
  Flint = 'flint',
  Flippin = 'flippin',
  Flora = 'flora',
  Florence = 'florence',
  Floresville = 'floresville',
  FlowerMound = 'flowerMound',
  Floyd = 'floyd',
  Floydada = 'floydada',
  Fluvanna = 'fluvanna',
  Flynn = 'flynn',
  Fob = 'fob',
  Follett = 'follett',
  Forest = 'forest',
  ForestHill = 'forestHill',
  Forestburg = 'forestburg',
  Forney = 'forney',
  Forreston = 'forreston',
  Forsan = 'forsan',
  FortGibson = 'fortGibson',
  FortPayne = 'fortPayne',
  FortSmith = 'fortSmith',
  FortStockton = 'fortStockton',
  FortTowson = 'fortTowson',
  FortWorth = 'fortWorth',
  FountainLake = 'fountainLake',
  Francis = 'francis',
  Franklin = 'franklin',
  Frankston = 'frankston',
  Fredericksburg = 'fredericksburg',
  Freeport = 'freeport',
  Freer = 'freer',
  Friendship = 'friendship',
  Friendswood = 'friendswood',
  Friona = 'friona',
  Frisco = 'frisco',
  Fritch = 'fritch',
  Frogville = 'frogville',
  Frost = 'frost',
  Fruitvale = 'fruitvale',
  Fulshear = 'fulshear',
  Fulton = 'fulton',
  Funston = 'funston',
  Gail = 'gail',
  Gainesville = 'gainesville',
  GalenaPark = 'galenaPark',
  Gallatin = 'gallatin',
  GallatinGateway = 'gallatinGateway',
  Galveston = 'galveston',
  Ganado = 'ganado',
  GardenCity = 'gardenCity',
  GardenRidge = 'gardenRidge',
  Gardiner = 'gardiner',
  Garland = 'garland',
  Garner = 'garner',
  Garrett = 'garrett',
  Garrison = 'garrison',
  Garvin = 'garvin',
  Gary = 'gary',
  Gatesville = 'gatesville',
  Gause = 'gause',
  Gaybluff = 'gaybluff',
  Geneva = 'geneva',
  GeorgeWest = 'georgeWest',
  Georgetown = 'georgetown',
  Geronimo = 'geronimo',
  Gettengruen = 'gettengruen',
  Gholson = 'gholson',
  Giddings = 'giddings',
  Gilbert = 'gilbert',
  Gillett = 'gillett',
  Gilmer = 'gilmer',
  Gladewater = 'gladewater',
  GlenCove = 'glenCove',
  GlenRose = 'glenRose',
  GlennHeights = 'glennHeights',
  Gober = 'gober',
  Godley = 'godley',
  Golden = 'golden',
  Goldsboro = 'goldsboro',
  Goldsmith = 'goldsmith',
  Goldthwaite = 'goldthwaite',
  Goliad = 'goliad',
  Golinda = 'golinda',
  Gonzales = 'gonzales',
  Goodland = 'goodland',
  Goodlow = 'goodlow',
  Goodrich = 'goodrich',
  Gordon = 'gordon',
  Gordonville = 'gordonville',
  Goree = 'goree',
  Gorman = 'gorman',
  Gouldbusk = 'gouldbusk',
  Graford = 'graford',
  Graham = 'graham',
  Granbury = 'granbury',
  GrandCayman = 'grandCayman',
  GrandJunction = 'grandJunction',
  GrandPrairie = 'grandPrairie',
  GrandSaline = 'grandSaline',
  Grandfalls = 'grandfalls',
  Grandview = 'grandview',
  Granger = 'granger',
  GraniteShoals = 'graniteShoals',
  Granjeno = 'granjeno',
  Grapeland = 'grapeland',
  Grapevine = 'grapevine',
  Gravette = 'gravette',
  GraysPrairie = 'graysPrairie',
  GreatExuma = 'greatExuma',
  Greenview = 'greenview',
  Greenville = 'greenville',
  Greenwood = 'greenwood',
  Gregory = 'gregory',
  GreyForest = 'greyForest',
  Groesbeck = 'groesbeck',
  Groom = 'groom',
  GrosIslet = 'grosIslet',
  Grosvenor = 'grosvenor',
  Groves = 'groves',
  Groveton = 'groveton',
  Gruver = 'gruver',
  GuatemalaCity = 'guatemalaCity',
  Guingamp = 'guingamp',
  GunBarrelCity = 'gunBarrelCity',
  Gunter = 'gunter',
  Gustine = 'gustine',
  Guthrie = 'guthrie',
  Guttengruen = 'guttengruen',
  Hackberry = 'hackberry',
  Hackett = 'hackett',
  Hagansport = 'hagansport',
  HaleCenter = 'haleCenter',
  Hallettsville = 'hallettsville',
  Hallsburg = 'hallsburg',
  Hallsville = 'hallsville',
  HaltomCity = 'haltomCity',
  Hamby = 'hamby',
  Hamilton = 'hamilton',
  Hamlin = 'hamlin',
  Hammond = 'hammond',
  Happy = 'happy',
  HappyLand = 'happyLand',
  Harbin = 'harbin',
  HardenCity = 'hardenCity',
  Hardin = 'hardin',
  HarkerHeights = 'harkerHeights',
  Harleton = 'harleton',
  Harlingen = 'harlingen',
  Harper = 'harper',
  Harris = 'harris',
  Harrold = 'harrold',
  Hart = 'hart',
  Hartsel = 'hartsel',
  Haske = 'haske',
  Haskell = 'haskell',
  Haslet = 'haslet',
  Hasse = 'hasse',
  Hatfield = 'hatfield',
  Haughton = 'haughton',
  HawkCove = 'hawkCove',
  Hawkins = 'hawkins',
  Hawley = 'hawley',
  Hays = 'hays',
  Hearne = 'hearne',
  Heartland = 'heartland',
  Heath = 'heath',
  Heavener = 'heavener',
  Hebron = 'hebron',
  Hebronville = 'hebronville',
  Hedley = 'hedley',
  HedwigVillage = 'hedwigVillage',
  Heidenheimer = 'heidenheimer',
  Helena = 'helena',
  Helotes = 'helotes',
  Hemphill = 'hemphill',
  Hempstead = 'hempstead',
  Hempwallace = 'hempwallace',
  Henderson = 'henderson',
  Hendersonville = 'hendersonville',
  Hendrix = 'hendrix',
  Henrietta = 'henrietta',
  Hereford = 'hereford',
  Hermleigh = 'hermleigh',
  HerveyBay = 'herveyBay',
  Hewitt = 'hewitt',
  HickoryCreek = 'hickoryCreek',
  Hico = 'hico',
  Hidalgo = 'hidalgo',
  Hideaway = 'hideaway',
  Higgins = 'higgins',
  HighlandHaven = 'highlandHaven',
  HighlandPark = 'highlandPark',
  HighlandVillage = 'highlandVillage',
  HillCountry = 'hillCountry',
  Hillcrest = 'hillcrest',
  Hillsboro = 'hillsboro',
  HilshireVillage = 'hilshireVillage',
  Hitchcock = 'hitchcock',
  Hobson = 'hobson',
  Hodges = 'hodges',
  HolidayLakes = 'holidayLakes',
  Holland = 'holland',
  Holliday = 'holliday',
  Hollis = 'hollis',
  HollyLakeRanch = 'hollyLakeRanch',
  HollywoodPark = 'hollywoodPark',
  HolmesBeach = 'holmesBeach',
  Homer = 'homer',
  Hondo = 'hondo',
  HoneyGrove = 'honeyGrove',
  Hooks = 'hooks',
  Horizon = 'horizon',
  HorseshoeBay = 'horseshoeBay',
  HotSprings = 'hotSprings',
  HotSpringsVillage = 'hotSpringsVillage',
  Houston = 'houston',
  Howardwick = 'howardwick',
  Howe = 'howe',
  Hubbard = 'hubbard',
  Huckabay = 'huckabay',
  Hudson = 'hudson',
  HudsonOaks = 'hudsonOaks',
  HughesSprings = 'hughesSprings',
  Hugo = 'hugo',
  Hulen = 'hulen',
  Humacao = 'humacao',
  Humble = 'humble',
  Hunt = 'hunt',
  HuntersCreekVillage = 'huntersCreekVillage',
  Huntington = 'huntington',
  Huntsville = 'huntsville',
  Hurst = 'hurst',
  Huskey = 'huskey',
  Hutchins = 'hutchins',
  Hutto = 'hutto',
  Huxley = 'huxley',
  Idabel = 'idabel',
  Idabell = 'idabell',
  Impact = 'impact',
  IndianCreek = 'indianCreek',
  IndianHills = 'indianHills',
  IndianLake = 'indianLake',
  Indianapolis = 'indianapolis',
  Industry = 'industry',
  Ingleside = 'ingleside',
  InglesideontheBay = 'inglesideontheBay',
  Ingram = 'ingram',
  Inverness = 'inverness',
  IowaColony = 'iowaColony',
  IowaPark = 'iowaPark',
  Ipswich = 'ipswich',
  Ira = 'ira',
  Iraan = 'iraan',
  Iredell = 'iredell',
  Irene = 'irene',
  IronSprings = 'ironSprings',
  Irving = 'irving',
  Italy = 'italy',
  Itasca = 'itasca',
  Ivanhoe = 'ivanhoe',
  Jacinto = 'jacinto',
  Jacksboro = 'jacksboro',
  Jackson = 'jackson',
  Jacksonville = 'jacksonville',
  Jaco = 'jaco',
  JamaicaBeach = 'jamaicaBeach',
  Jarrell = 'jarrell',
  Jasper = 'jasper',
  Jayton = 'jayton',
  Jefferson = 'jefferson',
  Jermyn = 'jermyn',
  JerseyVillage = 'jerseyVillage',
  Jesse = 'jesse',
  Jessieville = 'jessieville',
  Jewett = 'jewett',
  Jimtown = 'jimtown',
  Joaquin = 'joaquin',
  Johnson = 'johnson',
  Joinerville = 'joinerville',
  Jolly = 'jolly',
  Jones = 'jones',
  JonesCreek = 'jonesCreek',
  JonesMill = 'jonesMill',
  Jonesboro = 'jonesboro',
  Jonestown = 'jonestown',
  Jonesville = 'jonesville',
  Joplin = 'joplin',
  Josephine = 'josephine',
  Joshua = 'joshua',
  Jourdanton = 'jourdanton',
  Judson = 'judson',
  Junction = 'junction',
  JunctionCity = 'junctionCity',
  Justin = 'justin',
  Kaiser = 'kaiser',
  Kamay = 'kamay',
  KansasCity = 'kansasCity',
  Karnack = 'karnack',
  Karnes = 'karnes',
  KarnesCity = 'karnesCity',
  Katy = 'katy',
  Kaufman = 'kaufman',
  Keene = 'keene',
  Keller = 'keller',
  Kemah = 'kemah',
  Kemp = 'kemp',
  Kempner = 'kempner',
  Kendleton = 'kendleton',
  Kenedy = 'kenedy',
  Kenefic = 'kenefic',
  Kenefick = 'kenefick',
  Kennard = 'kennard',
  Kennedale = 'kennedale',
  Kent = 'kent',
  Kentuckytown = 'kentuckytown',
  Kerens = 'kerens',
  Kermit = 'kermit',
  Kerrville = 'kerrville',
  Kiersev = 'kiersev',
  Kildare = 'kildare',
  Kilgore = 'kilgore',
  Killeen = 'killeen',
  Kingsbury = 'kingsbury',
  Kingsland = 'kingsland',
  Kingston = 'kingston',
  Kingsville = 'kingsville',
  Kirby = 'kirby',
  Kirbyville = 'kirbyville',
  Kirvin = 'kirvin',
  Klondike = 'klondike',
  Knollwood = 'knollwood',
  Knox = 'knox',
  KnoxCity = 'knoxCity',
  Kopperl = 'kopperl',
  Kosse = 'kosse',
  Kountze = 'kountze',
  Kress = 'kress',
  Krugerville = 'krugerville',
  Krum = 'krum',
  Kurten = 'kurten',
  Kyle = 'kyle',
  LaCoste781 = 'laCoste781',
  LaFeria = 'laFeria',
  LaGrange = 'laGrange',
  LaJoya = 'laJoya',
  LaLibertad = 'laLibertad',
  LaMarque = 'laMarque',
  LaPorte = 'laPorte',
  LaRomana = 'laRomana',
  LaUnion = 'laUnion',
  LaVernia = 'laVernia',
  LaVilla = 'laVilla',
  LaWard = 'laWard',
  LaCoste790 = 'laCoste790',
  LacyLakeview = 'lacyLakeview',
  Ladonia = 'ladonia',
  Lafayette = 'lafayette',
  LagoVista = 'lagoVista',
  LagunaPark = 'lagunaPark',
  LagunaVista = 'lagunaVista',
  LairdHill = 'lairdHill',
  Lake = 'lake',
  LakeBridgeport = 'lakeBridgeport',
  LakeBrownwood = 'lakeBrownwood',
  LakeCatherine = 'lakeCatherine',
  LakeCisco = 'lakeCisco',
  LakeCreek = 'lakeCreek',
  LakeDallas = 'lakeDallas',
  LakeHamilton = 'lakeHamilton',
  LakeJackson = 'lakeJackson',
  LakeKiowa = 'lakeKiowa',
  LakeTanglewood = 'lakeTanglewood',
  LakeWorth = 'lakeWorth',
  Lakeport = 'lakeport',
  Lakeside = 'lakeside',
  Lakeview = 'lakeview',
  Lakeway = 'lakeway',
  LakewoodRanch = 'lakewoodRanch',
  LakewoodVillage = 'lakewoodVillage',
  Lamasco = 'lamasco',
  Lamesa = 'lamesa',
  Lampasas = 'lampasas',
  Lanark = 'lanark',
  Lancaster = 'lancaster',
  Laneville = 'laneville',
  Lannius = 'lannius',
  Lansing = 'lansing',
  Lantana = 'lantana',
  LapuLapuCity = 'lapuLapuCity',
  Laredo = 'laredo',
  Larue = 'larue',
  LasPinas = 'lasPinas',
  LasVegas = 'lasVegas',
  Latexo = 'latexo',
  Latta = 'latta',
  Laurel = 'laurel',
  Lavaca = 'lavaca',
  Lavon = 'lavon',
  Lawn = 'lawn',
  Lawrenceville = 'lawrenceville',
  Layou = 'layou',
  LeMans = 'leMans',
  League = 'league',
  Leakey = 'leakey',
  Leander = 'leander',
  Leary = 'leary',
  Lebanon = 'lebanon',
  Leesburg = 'leesburg',
  Lefors = 'lefors',
  Lenexa = 'lenexa',
  Leon = 'leon',
  LeonJunction = 'leonJunction',
  LeonValley = 'leonValley',
  Leona = 'leona',
  Leonard = 'leonard',
  Leroy = 'leroy',
  Levelland = 'levelland',
  Lewisville = 'lewisville',
  Lexington = 'lexington',
  Liberty = 'liberty',
  LibertyHill = 'libertyHill',
  Lillian = 'lillian',
  Lima = 'lima',
  Limoges = 'limoges',
  LincolnPark = 'lincolnPark',
  Lindale = 'lindale',
  Linden = 'linden',
  Lindsay = 'lindsay',
  Lingleville = 'lingleville',
  Lipan = 'lipan',
  LittleCity = 'littleCity',
  LittleElm = 'littleElm',
  LittleRiver = 'littleRiver',
  LittleRiverAcademy = 'littleRiverAcademy',
  LittleRock = 'littleRock',
  Littlefield = 'littlefield',
  LiveOak = 'liveOak',
  Liverpool = 'liverpool',
  Livingston = 'livingston',
  Llano = 'llano',
  Lockhart = 'lockhart',
  Lockney = 'lockney',
  Lodi = 'lodi',
  LogCabin = 'logCabin',
  Lohn = 'lohn',
  Lolita = 'lolita',
  Lometa = 'lometa',
  London = 'london',
  LoneOak = 'loneOak',
  LoneStar = 'loneStar',
  LongBranch = 'longBranch',
  Longview = 'longview',
  Lono = 'lono',
  Lonsdale = 'lonsdale',
  Loraine = 'loraine',
  Lorena = 'lorena',
  Lorenzo = 'lorenzo',
  Loreto = 'loreto',
  LosFresnos = 'losFresnos',
  LosIndios = 'losIndios',
  LosYbanez = 'losYbanez',
  Lott = 'lott',
  Lovelady = 'lovelady',
  Lovell = 'lovell',
  Loving = 'loving',
  Lowell = 'lowell',
  LowryCrossing = 'lowryCrossing',
  LoyalValley = 'loyalValley',
  Lubbock = 'lubbock',
  Lucas = 'lucas',
  Lueders = 'lueders',
  Luella = 'luella',
  Lufkin = 'lufkin',
  Luling = 'luling',
  Lumberton = 'lumberton',
  Lyford = 'lyford',
  Lyon = 'lyon',
  Lyons = 'lyons',
  Lytle = 'lytle',
  Mabank = 'mabank',
  Macdona = 'macdona',
  Madill = 'madill',
  Madisonville = 'madisonville',
  Madrid = 'madrid',
  Magazine = 'magazine',
  MagnetCove = 'magnetCove',
  Magnolia = 'magnolia',
  Mainz = 'mainz',
  Makati = 'makati',
  Malabon = 'malabon',
  Malaga = 'malaga',
  Malakoff = 'malakoff',
  Malone = 'malone',
  Malvern = 'malvern',
  Managua = 'managua',
  Manchaca = 'manchaca',
  Mandaluyong = 'mandaluyong',
  MandaueCity = 'mandaueCity',
  Manila = 'manila',
  Mannsville = 'mannsville',
  Manor = 'manor',
  Manosque = 'manosque',
  Mansfield = 'mansfield',
  Manvel = 'manvel',
  MarbleFalls = 'marbleFalls',
  Marcus = 'marcus',
  Marfa = 'marfa',
  Marietta = 'marietta',
  Marikina = 'marikina',
  Marion = 'marion',
  Markham = 'markham',
  Marlin = 'marlin',
  Marlow = 'marlow',
  Marquez = 'marquez',
  Marshall = 'marshall',
  MarshallCreek = 'marshallCreek',
  Mart = 'mart',
  MartinSprings = 'martinSprings',
  Martindale = 'martindale',
  Martinsville = 'martinsville',
  Maryneal = 'maryneal',
  Mason = 'mason',
  Matador = 'matador',
  Matagorda = 'matagorda',
  Mathis = 'mathis',
  Maud = 'maud',
  May = 'may',
  Maydelle = 'maydelle',
  Maypearl = 'maypearl',
  Maysfield = 'maysfield',
  McGregor = 'mcGregor',
  McLeod = 'mcLeod',
  McAlester = 'mcAlester',
  McAllen = 'mcAllen',
  McBride = 'mcBride',
  McCamey = 'mcCamey',
  McCaulley = 'mcCaulley',
  McComb = 'mcComb',
  McKinney = 'mcKinney',
  McLean = 'mcLean',
  McLendonChisholm = 'mcLendonChisholm',
  McNeil = 'mcNeil',
  McQueeney = 'mcQueeney',
  Mead = 'mead',
  Meadow = 'meadow',
  Meadowlakes = 'meadowlakes',
  MeadowsPlace = 'meadowsPlace',
  Megargel = 'megargel',
  Melissa = 'melissa',
  Melvin = 'melvin',
  Memphis = 'memphis',
  Mena = 'mena',
  Menard = 'menard',
  Mentone = 'mentone',
  Mercedes = 'mercedes',
  Mercury = 'mercury',
  Meridian = 'meridian',
  Merit = 'merit',
  Merkel = 'merkel',
  Mertens = 'mertens',
  Mertzon = 'mertzon',
  Mesquite = 'mesquite',
  Metapan = 'metapan',
  MetcalfGap = 'metcalfGap',
  Mexia = 'mexia',
  Mexico = 'mexico',
  Miami = 'miami',
  MiamiBeach = 'miamiBeach',
  Mico = 'mico',
  Midfield = 'midfield',
  Midland = 'midland',
  Midlothian = 'midlothian',
  Midway = 'midway',
  Milano = 'milano',
  Milburn = 'milburn',
  Mildred = 'mildred',
  Miles = 'miles',
  Milford = 'milford',
  MillCreek = 'millCreek',
  MillerGrove = 'millerGrove',
  MillersCove = 'millersCove',
  Millersview = 'millersview',
  Millerton = 'millerton',
  Millican = 'millican',
  Millsap = 'millsap',
  Minden = 'minden',
  Mineola = 'mineola',
  MineralWells = 'mineralWells',
  Mingus = 'mingus',
  Mission = 'mission',
  Missouri = 'missouri',
  Mobeetie = 'mobeetie',
  Mobile = 'mobile',
  MohoCaye = 'mohoCaye',
  Monahans = 'monahans',
  Monkstown = 'monkstown',
  Monrovia = 'monrovia',
  MontBelvieu = 'montBelvieu',
  Montague = 'montague',
  Montalba = 'montalba',
  MontegoBay = 'montegoBay',
  Monterrey = 'monterrey',
  Montgomery = 'montgomery',
  Montilly = 'montilly',
  Montpellier = 'montpellier',
  Moody = 'moody',
  MooreStation = 'mooreStation',
  Mooring = 'mooring',
  Moran = 'moran',
  Morgan = 'morgan',
  MorganMill = 'morganMill',
  MorgansPoint = 'morgansPoint',
  MorgansPointResort = 'morgansPointResort',
  MorningStar = 'morningStar',
  Morton = 'morton',
  Mougins = 'mougins',
  Moulton = 'moulton',
  Mound = 'mound',
  MountCalm = 'mountCalm',
  MountEnterprise = 'mountEnterprise',
  MountIda = 'mountIda',
  MountPleasant = 'mountPleasant',
  MountSelman = 'mountSelman',
  MountVernon = 'mountVernon',
  Mountain = 'mountain',
  MountainHome = 'mountainHome',
  MountainValley = 'mountainValley',
  Mountainburg = 'mountainburg',
  Moyers = 'moyers',
  MtHerman = 'mtHerman',
  MtZion = 'mtZion',
  Muenster = 'muenster',
  Muldrow = 'muldrow',
  Muleshoe = 'muleshoe',
  Mullin = 'mullin',
  Mumford = 'mumford',
  Munday = 'munday',
  Muntinglupa = 'muntinglupa',
  Murchison = 'murchison',
  Murphy = 'murphy',
  Muse = 'muse',
  Muskogee = 'muskogee',
  Mustang = 'mustang',
  MustangRidge = 'mustangRidge',
  Myra = 'myra',
  Nacogdoches = 'nacogdoches',
  Nance = 'nance',
  Naples = 'naples',
  Nash = 'nash',
  Nashoba = 'nashoba',
  NassauBay = 'nassauBay',
  Natalia = 'natalia',
  Navarro = 'navarro',
  Navasota = 'navasota',
  Navotas = 'navotas',
  Nazareth = 'nazareth',
  Neches = 'neches',
  Nederland = 'nederland',
  Needville = 'needville',
  Nelson = 'nelson',
  Nelta = 'nelta',
  Nemo = 'nemo',
  Nesbitt = 'nesbitt',
  Nevada = 'nevada',
  NewBaden = 'newBaden',
  NewBerlin = 'newBerlin',
  NewBoston = 'newBoston',
  NewBraunfels = 'newBraunfels',
  NewCaney = 'newCaney',
  NewChapelHill = 'newChapelHill',
  NewFairview = 'newFairview',
  NewHome = 'newHome',
  NewHope = 'newHope',
  NewLondon = 'newLondon',
  NewProvidence = 'newProvidence',
  NewRingold = 'newRingold',
  NewSalem = 'newSalem',
  NewSalisbury = 'newSalisbury',
  NewSmyrnaBeach = 'newSmyrnaBeach',
  NewSummerfield = 'newSummerfield',
  NewUlm = 'newUlm',
  NewWaverly = 'newWaverly',
  NewWoodville = 'newWoodville',
  Newark = 'newark',
  Newcastle = 'newcastle',
  Newton = 'newton',
  Neylandville = 'neylandville',
  Nice = 'nice',
  Nida = 'nida',
  Niederwald = 'niederwald',
  Nimes = 'nimes',
  Ninnekah = 'ninnekah',
  Nixon = 'nixon',
  NoCity = 'noCity',
  Nocona = 'nocona',
  Nolan = 'nolan',
  Nolanville = 'nolanville',
  Nome = 'nome',
  Noodle = 'noodle',
  Noonday = 'noonday',
  Nordheim = 'nordheim',
  Normangee = 'normangee',
  NorthCleveland = 'northCleveland',
  NorthPort = 'northPort',
  NorthRichlandHills = 'northRichlandHills',
  Northcrest = 'northcrest',
  Northlake = 'northlake',
  Northpole = 'northpole',
  Norwalk = 'norwalk',
  Norway = 'norway',
  Norwood = 'norwood',
  Novice = 'novice',
  NTREISTESTONLY = 'nTREISTESTONLY',
  Nugent = 'nugent',
  Nunlee = 'nunlee',
  OakGrove = 'oakGrove',
  OakLeaf = 'oakLeaf',
  OakPoint = 'oakPoint',
  OakRidge = 'oakRidge',
  OakRidgeNorth = 'oakRidgeNorth',
  OakValley = 'oakValley',
  Oakhurst = 'oakhurst',
  Oakland = 'oakland',
  Oakman = 'oakman',
  Oakville = 'oakville',
  Oakwood = 'oakwood',
  OBrien = 'oBrien',
  OceanCity = 'oceanCity',
  Odell = 'odell',
  Odem = 'odem',
  Odessa = 'odessa',
  ODonnell = 'oDonnell',
  Oglesby = 'oglesby',
  OhioCity = 'ohioCity',
  OilCenter = 'oilCenter',
  Ojochal = 'ojochal',
  OklahomaCity = 'oklahomaCity',
  Oklaunion = 'oklaunion',
  OldGlory = 'oldGlory',
  OldRiverWinfree = 'oldRiverWinfree',
  Olden = 'olden',
  OlmosPark = 'olmosPark',
  Olney = 'olney',
  Olton = 'olton',
  Omaha = 'omaha',
  Onalaska = 'onalaska',
  OpdykeWest = 'opdykeWest',
  Oplin = 'oplin',
  Orange = 'orange',
  OrangeGrove = 'orangeGrove',
  Oranjestad = 'oranjestad',
  Orchard = 'orchard',
  Ordgrant = 'ordgrant',
  OreCity = 'oreCity',
  Otto = 'otto',
  Ovalo = 'ovalo',
  Overbrook = 'overbrook',
  Overton = 'overton',
  Ovilla = 'ovilla',
  Owens = 'owens',
  Owensville = 'owensville',
  Owenton = 'owenton',
  Oxford = 'oxford',
  OysterCreek = 'oysterCreek',
  Ozona = 'ozona',
  Pezenas = 'pezenas',
  Paducah = 'paducah',
  PagosaSprings = 'pagosaSprings',
  PaintRock = 'paintRock',
  Palacios = 'palacios',
  Palestine = 'palestine',
  Palisades = 'palisades',
  PalmValley = 'palmValley',
  Palmer = 'palmer',
  Palmetto = 'palmetto',
  Palmhurst = 'palmhurst',
  Palmview = 'palmview',
  PaloPinto = 'paloPinto',
  Paluxy = 'paluxy',
  Pampa = 'pampa',
  PanamaCity = 'panamaCity',
  PanamaCityBeach = 'panamaCityBeach',
  Panhandle = 'panhandle',
  PannaMaria = 'pannaMaria',
  Panola = 'panola',
  PanoramaVillage = 'panoramaVillage',
  Pantego = 'pantego',
  Paradise = 'paradise',
  Paranaque = 'paranaque',
  Paris = 'paris',
  Parker = 'parker',
  Paron = 'paron',
  Parrish = 'parrish',
  Pasadena = 'pasadena',
  Pasay = 'pasay',
  Pasig = 'pasig',
  Pateros = 'pateros',
  Pattison = 'pattison',
  PattonVillage = 'pattonVillage',
  Pattonville = 'pattonville',
  PayneSprings = 'payneSprings',
  Peacock = 'peacock',
  Peadenville = 'peadenville',
  Pearcy = 'pearcy',
  Pearland = 'pearland',
  Pearsall = 'pearsall',
  Peaster = 'peaster',
  PecanGap = 'pecanGap',
  PecanHill = 'pecanHill',
  Pecos = 'pecos',
  PelicanBay = 'pelicanBay',
  Pendleton = 'pendleton',
  Penelope = 'penelope',
  PeninsulaPapagayo = 'peninsulaPapagayo',
  Penitas = 'penitas',
  PennValley = 'pennValley',
  Peoria = 'peoria',
  Perla = 'perla',
  PernitasPoint = 'pernitasPoint',
  Perrin = 'perrin',
  Perry = 'perry',
  Perryton = 'perryton',
  Pertuis = 'pertuis',
  Peru = 'peru',
  Petersburg = 'petersburg',
  Petrolia = 'petrolia',
  Petronila = 'petronila',
  Petty = 'petty',
  Pettyview = 'pettyview',
  Pflugerville = 'pflugerville',
  Pharr = 'pharr',
  Phoenix = 'phoenix',
  Pickens = 'pickens',
  Pickett = 'pickett',
  Pickton = 'pickton',
  Pickwick = 'pickwick',
  PiedrasNegras = 'piedrasNegras',
  Pike = 'pike',
  Pikeville = 'pikeville',
  PilotGrove = 'pilotGrove',
  PilotPoint = 'pilotPoint',
  PineForest = 'pineForest',
  PineIsland = 'pineIsland',
  Pinehurst = 'pinehurst',
  Pineland = 'pineland',
  PineyPointVillage = 'pineyPointVillage',
  Pioneer = 'pioneer',
  Pittsburg = 'pittsburg',
  Placid = 'placid',
  Plains = 'plains',
  Plainview = 'plainview',
  Plano = 'plano',
  Platter = 'platter',
  PlayaBandera = 'playaBandera',
  PlayaBlanca = 'playaBlanca',
  PlayadelCarmen = 'playadelCarmen',
  PlayadelCoco = 'playadelCoco',
  PlayaHermosa = 'playaHermosa',
  Pleak = 'pleak',
  PleasantHill = 'pleasantHill',
  PleasantValley = 'pleasantValley',
  Pleasanton = 'pleasanton',
  Pledger = 'pledger',
  PlumGrove = 'plumGrove',
  Poetry = 'poetry',
  Point = 'point',
  PointBlank = 'pointBlank',
  PointComfort = 'pointComfort',
  PointDecar = 'pointDecar',
  Ponder = 'ponder',
  Pontotoc = 'pontotoc',
  PontSaintEsprit = 'pontSaintEsprit',
  Poolville = 'poolville',
  PortAransas = 'portAransas',
  PortArthur = 'portArthur',
  PortBolivar = 'portBolivar',
  PortIsabel = 'portIsabel',
  PortLavaca = 'portLavaca',
  PortNeches = 'portNeches',
  PortOrange = 'portOrange',
  Portland = 'portland',
  PossumKingdomLake = 'possumKingdomLake',
  Post = 'post',
  PostOakBend = 'postOakBend',
  Poteau = 'poteau',
  Poteet = 'poteet',
  Poth = 'poth',
  Potosi = 'potosi',
  Pottsboro = 'pottsboro',
  Pottsville = 'pottsville',
  Powderly = 'powderly',
  Powell = 'powell',
  Poynor = 'poynor',
  PrairieHill = 'prairieHill',
  PrairieLea = 'prairieLea',
  PrairieView = 'prairieView',
  Praslin = 'praslin',
  Pray = 'pray',
  Premont = 'premont',
  Presidio = 'presidio',
  Preston = 'preston',
  Prestonsburg = 'prestonsburg',
  Price = 'price',
  Priddy = 'priddy',
  Primera = 'primera',
  Princeton = 'princeton',
  Proctor = 'proctor',
  Progreso = 'progreso',
  ProgresoLakes = 'progresoLakes',
  Prosper = 'prosper',
  ProvidenceVillage = 'providenceVillage',
  Provincetown = 'provincetown',
  Pucon = 'pucon',
  PuntaMita = 'puntaMita',
  Purcell = 'purcell',
  Purdon = 'purdon',
  Purmela = 'purmela',
  Purves = 'purves',
  Putnam = 'putnam',
  Pyote = 'pyote',
  Quanah = 'quanah',
  QueenCity = 'queenCity',
  Quemado = 'quemado',
  QuezonCity = 'quezonCity',
  Quimper = 'quimper',
  Quinlan = 'quinlan',
  Quintana = 'quintana',
  Quitaque = 'quitaque',
  Quitman = 'quitman',
  Rainbow = 'rainbow',
  Ralls = 'ralls',
  RanchoViejo = 'ranchoViejo',
  Randlett = 'randlett',
  Randolph = 'randolph',
  Ranger = 'ranger',
  Rangerville = 'rangerville',
  Rankin = 'rankin',
  Ratcliff = 'ratcliff',
  Ravenna = 'ravenna',
  Ravia = 'ravia',
  Raymondville = 'raymondville',
  Reagan = 'reagan',
  RedLick = 'redLick',
  RedOak = 'redOak',
  RedRiver = 'redRiver',
  Redwater = 'redwater',
  Reese = 'reese',
  Refugio = 'refugio',
  Regency = 'regency',
  Reklaw = 'reklaw',
  Remsenburg = 'remsenburg',
  Rendon = 'rendon',
  Reno = 'reno',
  Retreat = 'retreat',
  Reydon = 'reydon',
  RheaMills = 'rheaMills',
  Rhome = 'rhome',
  Rice = 'rice',
  Richardson = 'richardson',
  Richland = 'richland',
  RichlandHills = 'richlandHills',
  RichlandSprings = 'richlandSprings',
  Richmond = 'richmond',
  Richwood = 'richwood',
  Ridge = 'ridge',
  Ridgeway = 'ridgeway',
  Riesel = 'riesel',
  Ringgold = 'ringgold',
  Ringling = 'ringling',
  Ringold = 'ringold',
  RioBravo = 'rioBravo',
  RioDeJaneiro = 'rioDeJaneiro',
  RioGrandeCity = 'rioGrandeCity',
  RioHato = 'rioHato',
  RioHondo = 'rioHondo',
  RioMedina = 'rioMedina',
  RioVista = 'rioVista',
  RisingStar = 'risingStar',
  RiverOaks = 'riverOaks',
  Riverby = 'riverby',
  Riverside = 'riverside',
  Roane = 'roane',
  Roanoke = 'roanoke',
  RoaringSprings = 'roaringSprings',
  Roatan = 'roatan',
  RobertLee = 'robertLee',
  Roberta = 'roberta',
  Robinson = 'robinson',
  Robs = 'robs',
  Robstown = 'robstown',
  Roby = 'roby',
  Rochelle = 'rochelle',
  Rochester = 'rochester',
  RockSprings = 'rockSprings',
  Rockdale = 'rockdale',
  Rockett = 'rockett',
  Rockport = 'rockport',
  Rockport2 = 'rockport2',
  Rocksprings = 'rocksprings',
  Rockwall = 'rockwall',
  Rockwood = 'rockwood',
  Rocky = 'rocky',
  RockyMound = 'rockyMound',
  Roff = 'roff',
  Rogers = 'rogers',
  Rolia = 'rolia',
  Roll = 'roll',
  Rollingwood = 'rollingwood',
  RomanForest = 'romanForest',
  Romans = 'romans',
  Rome = 'rome',
  Ropesville = 'ropesville',
  Rosanky = 'rosanky',
  Roscoe = 'roscoe',
  Rose = 'rose',
  RoseHillAcres = 'roseHillAcres',
  Rosebud = 'rosebud',
  Rosenberg = 'rosenberg',
  Ross = 'ross',
  Rosser = 'rosser',
  Rosston = 'rosston',
  Rotan = 'rotan',
  RoundMountain = 'roundMountain',
  RoundRock = 'roundRock',
  RoundTop = 'roundTop',
  Rowden = 'rowden',
  Rowlett = 'rowlett',
  Roxton = 'roxton',
  Royal = 'royal',
  RoyseCity = 'royseCity',
  Rubottom = 'rubottom',
  Rule = 'rule',
  RunawayBay = 'runawayBay',
  Runge = 'runge',
  Rusk = 'rusk',
  Russett = 'russett',
  RyanPark = 'ryanPark',
  Sabinal = 'sabinal',
  Sachse = 'sachse',
  Sacul = 'sacul',
  Sadler = 'sadler',
  Saginaw = 'saginaw',
  SaintClairsville = 'saintClairsville',
  SaintHedwig = 'saintHedwig',
  SaintJo = 'saintJo',
  SaintJoseph = 'saintJoseph',
  SaintPaul = 'saintPaul',
  Salado = 'salado',
  Salem = 'salem',
  Salesville = 'salesville',
  Salida = 'salida',
  SalondeProvence = 'salondeProvence',
  SaltGap = 'saltGap',
  Saltillo = 'saltillo',
  SanAngelo = 'sanAngelo',
  SanAntonio = 'sanAntonio',
  SanAugustine = 'sanAugustine',
  SanBenito = 'sanBenito',
  SanDiego = 'sanDiego',
  SanElizario = 'sanElizario',
  SanFelipe = 'sanFelipe',
  SanIsidro = 'sanIsidro',
  SanJose = 'sanJose',
  SanJuan = 'sanJuan',
  SanJuandelMonte = 'sanJuandelMonte',
  SanLeanna = 'sanLeanna',
  SanMarcos = 'sanMarcos',
  SanMiguel = 'sanMiguel',
  SanPatricio = 'sanPatricio',
  SanPedro = 'sanPedro',
  SanPerlita = 'sanPerlita',
  SanSaba = 'sanSaba',
  SanSalvador = 'sanSalvador',
  SanSebastian = 'sanSebastian',
  Sanctuary = 'sanctuary',
  Sandbluff = 'sandbluff',
  Sanderson = 'sanderson',
  Sanger = 'sanger',
  SansomPark = 'sansomPark',
  SantaAna = 'santaAna',
  SantaAnna = 'santaAnna',
  SantaFe = 'santaFe',
  SantaMarta = 'santaMarta',
  SantaRosa = 'santaRosa',
  Santo = 'santo',
  SantoDomingo = 'santoDomingo',
  Sarasota = 'sarasota',
  Sardis = 'sardis',
  Satin = 'satin',
  Savannah = 'savannah',
  Savoy = 'savoy',
  Sawyer = 'sawyer',
  Sayre = 'sayre',
  Schertz = 'schertz',
  Schulenburg = 'schulenburg',
  Schwertner = 'schwertner',
  Scotland = 'scotland',
  Scottsville = 'scottsville',
  Scroggins = 'scroggins',
  Scurry = 'scurry',
  Seabrook = 'seabrook',
  Seadrift = 'seadrift',
  Seagoville = 'seagoville',
  Seagraves = 'seagraves',
  Sealy = 'sealy',
  Sedalia = 'sedalia',
  Sedona = 'sedona',
  Seguin = 'seguin',
  Selden = 'selden',
  Selma = 'selma',
  SelmanCity = 'selmanCity',
  Seminole = 'seminole',
  Sens = 'sens',
  Sentinel = 'sentinel',
  SevenOaks = 'sevenOaks',
  SevenPoints = 'sevenPoints',
  Sevilla = 'sevilla',
  Seymore = 'seymore',
  Seymour = 'seymour',
  ShadyShores = 'shadyShores',
  Shamrock = 'shamrock',
  ShavanoPark = 'shavanoPark',
  Shenandoah = 'shenandoah',
  Shepherd = 'shepherd',
  Sherman = 'sherman',
  Shiner = 'shiner',
  Shirley = 'shirley',
  Shive = 'shive',
  Shoreacres = 'shoreacres',
  Sidney = 'sidney',
  SierraBlanca = 'sierraBlanca',
  Silo = 'silo',
  Silsbee = 'silsbee',
  Silverton = 'silverton',
  Simms = 'simms',
  Simonton = 'simonton',
  Sinton = 'sinton',
  SiouxFalls = 'siouxFalls',
  Skelly = 'skelly',
  Slaton = 'slaton',
  Slidell = 'slidell',
  Smiley = 'smiley',
  Smithland = 'smithland',
  Smithville = 'smithville',
  Smyer = 'smyer',
  Snook = 'snook',
  Snoqualmie = 'snoqualmie',
  Snyder = 'snyder',
  SocialHill = 'socialHill',
  Socorro = 'socorro',
  Somerset = 'somerset',
  Somerville = 'somerville',
  Sonora = 'sonora',
  Sonsonate = 'sonsonate',
  Soper = 'soper',
  Sosua = 'sosua',
  SourLake = 'sourLake',
  SouthBend = 'southBend',
  SouthHouston = 'southHouston',
  SouthLakeTahoe = 'southLakeTahoe',
  SouthMountain = 'southMountain',
  SouthPadreIsland = 'southPadreIsland',
  Southerland = 'southerland',
  Southlake = 'southlake',
  Southmayd = 'southmayd',
  SouthsidePlace = 'southsidePlace',
  Spearman = 'spearman',
  Spicewood = 'spicewood',
  Splendora = 'splendora',
  Spofford = 'spofford',
  Spring = 'spring',
  SpringBranch = 'springBranch',
  SpringValley = 'springValley',
  Springdale = 'springdale',
  Springlake = 'springlake',
  Springtown = 'springtown',
  Spur = 'spur',
  StPaul = 'stPaul',
  StAndrews = 'stAndrews',
  StEmilion = 'stEmilion',
  StHedwig = 'stHedwig',
  StRaphael = 'stRaphael',
  StSimonsIsland = 'stSimonsIsland',
  StTropez = 'stTropez',
  Stafford = 'stafford',
  Stagecoach = 'stagecoach',
  Stamford = 'stamford',
  Stanton = 'stanton',
  Staples = 'staples',
  Star = 'star',
  StarHarbor = 'starHarbor',
  Stephenville = 'stephenville',
  Sterling = 'sterling',
  SterlingCity = 'sterlingCity',
  Stillwater = 'stillwater',
  Stinnett = 'stinnett',
  Stockdale = 'stockdale',
  StomsriverVillage = 'stomsriverVillage',
  Stonewall = 'stonewall',
  Stratford = 'stratford',
  Strawn = 'strawn',
  Streetman = 'streetman',
  StrongCity = 'strongCity',
  Sudan = 'sudan',
  SugarLand = 'sugarLand',
  Sulphur = 'sulphur',
  SulphurBluff = 'sulphurBluff',
  SulphurSprings = 'sulphurSprings',
  Sumner = 'sumner',
  SunCityWest = 'sunCityWest',
  SunValley = 'sunValley',
  Sundown = 'sundown',
  Sunnyvale = 'sunnyvale',
  Sunray = 'sunray',
  SunriseBeachVillage = 'sunriseBeachVillage',
  Sunset = 'sunset',
  SunsetValley = 'sunsetValley',
  SurfsideBeach = 'surfsideBeach',
  SutherlandSprings = 'sutherlandSprings',
  Sweeny = 'sweeny',
  Sweetwater = 'sweetwater',
  Swink = 'swink',
  Sylvester = 'sylvester',
  Taft = 'taft',
  Taguig = 'taguig',
  Tahoka = 'tahoka',
  Talco = 'talco',
  Talihina = 'talihina',
  Talpa = 'talpa',
  Talty = 'talty',
  Tappahannock = 'tappahannock',
  Tarcoles = 'tarcoles',
  Tatum = 'tatum',
  Taylor = 'taylor',
  TaylorLakeVillage = 'taylorLakeVillage',
  Teague = 'teague',
  Tehuacana = 'tehuacana',
  Telephone = 'telephone',
  Telico = 'telico',
  Telluride = 'telluride',
  Temple = 'temple',
  Tenaha = 'tenaha',
  TennesseeColony = 'tennesseeColony',
  TerraCeia = 'terraCeia',
  Terral = 'terral',
  Terrell = 'terrell',
  TerrellHills = 'terrellHills',
  Texarkana = 'texarkana',
  Texas = 'texas',
  Texhoma = 'texhoma',
  Texline = 'texline',
  Thackerville = 'thackerville',
  TheColony = 'theColony',
  TheCrane = 'theCrane',
  TheHills = 'theHills',
  TheWoodlands = 'theWoodlands',
  Thompsons = 'thompsons',
  Thorndale = 'thorndale',
  Thornton = 'thornton',
  Thorntonville = 'thorntonville',
  Thrall = 'thrall',
  ThreeRivers = 'threeRivers',
  Thrifty = 'thrifty',
  Throckmorton = 'throckmorton',
  Tigard = 'tigard',
  TikiIsland = 'tikiIsland',
  Tilden = 'tilden',
  TimbercreekCanyon = 'timbercreekCanyon',
  Timpson = 'timpson',
  Tioga = 'tioga',
  Tira = 'tira',
  Tishomingo = 'tishomingo',
  Tivoli = 'tivoli',
  Toco = 'toco',
  ToddMission = 'toddMission',
  Tolar = 'tolar',
  Tom = 'tom',
  TomBean = 'tomBean',
  Tomball = 'tomball',
  Tool = 'tool',
  Tornillo = 'tornillo',
  Toulouse = 'toulouse',
  Tow = 'tow',
  Toyah = 'toyah',
  Traskwood = 'traskwood',
  Trent = 'trent',
  Trenton = 'trenton',
  Trickham = 'trickham',
  Trinidad = 'trinidad',
  Trinity = 'trinity',
  TrophyClub = 'trophyClub',
  Troup = 'troup',
  Troy = 'troy',
  Trumbull = 'trumbull',
  Tulia = 'tulia',
  Tupelo = 'tupelo',
  Turkey = 'turkey',
  TurksCaicosIslands = 'turksCaicosIslands',
  Turney = 'turney',
  Tuscany = 'tuscany',
  Tuscola = 'tuscola',
  Tuskahoma = 'tuskahoma',
  Tye = 'tye',
  Tyler = 'tyler',
  Uhland = 'uhland',
  Uncertain = 'uncertain',
  Unger = 'unger',
  UnionGrove = 'unionGrove',
  UnionHill = 'unionHill',
  UnionValley = 'unionValley',
  UniversalCity = 'universalCity',
  UniversityPark = 'universityPark',
  Usulutan = 'usulutan',
  Utica = 'utica',
  Utila = 'utila',
  Uvalde = 'uvalde',
  Uvita = 'uvita',
  Uzes = 'uzes',
  Valencia = 'valencia',
  Valentine = 'valentine',
  Valenzuela = 'valenzuela',
  Valera = 'valera',
  Valiant = 'valiant',
  ValleyMills = 'valleyMills',
  ValleySpring = 'valleySpring',
  ValleyView = 'valleyView',
  Valliant = 'valliant',
  Van = 'van',
  VanAlstyne = 'vanAlstyne',
  VanBuren = 'vanBuren',
  VanHorn = 'vanHorn',
  VanVleck = 'vanVleck',
  Varna = 'varna',
  Vaucluse = 'vaucluse',
  Vega = 'vega',
  Venus = 'venus',
  Vernon = 'vernon',
  Vichy = 'vichy',
  Victoria = 'victoria',
  Vidor = 'vidor',
  Vigo = 'vigo',
  Vilas = 'vilas',
  Villefranche = 'villefranche',
  Vimy = 'vimy',
  Vinita = 'vinita',
  Vinton = 'vinton',
  Voca = 'voca',
  VonOrmy = 'vonOrmy',
  Voss = 'voss',
  Waco = 'waco',
  Wade = 'wade',
  Wadsworth = 'wadsworth',
  Waelder = 'waelder',
  Wagner = 'wagner',
  Wake = 'wake',
  WakeVillage = 'wakeVillage',
  Walburg = 'walburg',
  Waldron = 'waldron',
  Waller = 'waller',
  Wallis = 'wallis',
  WalnutSprings = 'walnutSprings',
  Walters = 'walters',
  Wamego = 'wamego',
  Warren = 'warren',
  Washington = 'washington',
  Waskom = 'waskom',
  Watauga = 'watauga',
  Watson = 'watson',
  Waxahachie = 'waxahachie',
  Weatherford = 'weatherford',
  Weaver = 'weaver',
  Webster = 'webster',
  Weimar = 'weimar',
  Weinert = 'weinert',
  Weir = 'weir',
  Wellborn = 'wellborn',
  Wellington = 'wellington',
  Wellman = 'wellman',
  Wells = 'wells',
  Wellsboro = 'wellsboro',
  Weslaco = 'weslaco',
  West = 'west',
  WestColumbia = 'westColumbia',
  WestFargo = 'westFargo',
  WestLakeHills = 'westLakeHills',
  WestOrange = 'westOrange',
  WestTawakoni = 'westTawakoni',
  WestUniversityPlace = 'westUniversityPlace',
  Westbrook = 'westbrook',
  Westlake = 'westlake',
  Westminster = 'westminster',
  Weston = 'weston',
  WestoverHills = 'westoverHills',
  WestworthVillage = 'westworthVillage',
  Wharton = 'wharton',
  Wheeler = 'wheeler',
  Wheelock = 'wheelock',
  WhiteDeer = 'whiteDeer',
  WhiteOak = 'whiteOak',
  WhiteSettlement = 'whiteSettlement',
  Whiteface = 'whiteface',
  Whitehouse = 'whitehouse',
  Whitesboro = 'whitesboro',
  Whitewright = 'whitewright',
  Whitman = 'whitman',
  Whitney = 'whitney',
  Whitsett = 'whitsett',
  Whitt = 'whitt',
  WichitaFalls = 'wichitaFalls',
  Wickett = 'wickett',
  Wilburton = 'wilburton',
  Williamstown = 'williamstown',
  Willis = 'willis',
  WillowCity = 'willowCity',
  WillowPark = 'willowPark',
  WillsPoint = 'willsPoint',
  Wilmer = 'wilmer',
  Wilson = 'wilson',
  Wimberley = 'wimberley',
  Winchell = 'winchell',
  Windcrest = 'windcrest',
  Windom = 'windom',
  Windthorst = 'windthorst',
  Winfield = 'winfield',
  Wingate = 'wingate',
  Wink = 'wink',
  Winnsboro = 'winnsboro',
  Winona = 'winona',
  WinterHaven = 'winterHaven',
  WinterPark = 'winterPark',
  Winters = 'winters',
  Wister = 'wister',
  WixonValley = 'wixonValley',
  Woden = 'woden',
  WolfeCity = 'wolfeCity',
  Woodbranch = 'woodbranch',
  Woodcreek = 'woodcreek',
  WoodlandPark = 'woodlandPark',
  Woodlawn = 'woodlawn',
  Woodloch = 'woodloch',
  Woodsboro = 'woodsboro',
  Woodson = 'woodson',
  Woodville = 'woodville',
  Woodway = 'woodway',
  Wortham = 'wortham',
  WrightCity = 'wrightCity',
  Wylie = 'wylie',
  Wynnewood = 'wynnewood',
  Yancey = 'yancey',
  Yantis = 'yantis',
  Yellville = 'yellville',
  Yoakum = 'yoakum',
  York = 'york',
  Yreka = 'yreka',
  Yuba = 'yuba',
  Zapata = 'zapata',
  Zavalla = 'zavalla',
  Zephyr = 'zephyr',
  Zirahuen = 'zirahuen',
  NotApplicable = 'notApplicable',
  PrairieRidge = 'prairieRidge'
}

export const DfwCitiesLabel: Record<DfwCities, string> = {
  [DfwCities.Abbott]: 'Abbott',
  [DfwCities.Abernat]: 'Abernat',
  [DfwCities.Abilene]: 'Abilene',
  [DfwCities.Achille]: 'Achille',
  [DfwCities.Ackerly]: 'Ackerly',
  [DfwCities.Acton]: 'Acton',
  [DfwCities.Ada]: 'Ada',
  [DfwCities.Adamsville]: 'Adamsville',
  [DfwCities.Addison]: 'Addison',
  [DfwCities.Adkins]: 'Adkins',
  [DfwCities.Adrian]: 'Adrian',
  [DfwCities.Agen]: 'Agen',
  [DfwCities.AguaDulce]: 'Agua Dulce',
  [DfwCities.Ahloso]: 'Ahloso',
  [DfwCities.AixEnProvence]: 'Aix-en-Provence',
  [DfwCities.Alamo]: 'Alamo',
  [DfwCities.AlamoHeights]: 'Alamo Heights',
  [DfwCities.Alamogordo]: 'Alamogordo',
  [DfwCities.Alba]: 'Alba',
  [DfwCities.Albany]: 'Albany',
  [DfwCities.Aledo]: 'Aledo',
  [DfwCities.Alexander]: 'Alexander',
  [DfwCities.Algoa]: 'Algoa',
  [DfwCities.Alicante]: 'Alicante',
  [DfwCities.Alice]: 'Alice',
  [DfwCities.Allen]: 'Allen',
  [DfwCities.Allison]: 'Allison',
  [DfwCities.Alma]: 'Alma',
  [DfwCities.Alpine]: 'Alpine',
  [DfwCities.Alto]: 'Alto',
  [DfwCities.Alton]: 'Alton',
  [DfwCities.Alvarado]: 'Alvarado',
  [DfwCities.Alvin]: 'Alvin',
  [DfwCities.Alvord]: 'Alvord',
  [DfwCities.Amarillo]: 'Amarillo',
  [DfwCities.Ambrose]: 'Ambrose',
  [DfwCities.Ames]: 'Ames',
  [DfwCities.Amherst]: 'Amherst',
  [DfwCities.Anahuac]: 'Anahuac',
  [DfwCities.Anderson]: 'Anderson',
  [DfwCities.Andrews]: 'Andrews',
  [DfwCities.AngelFire]: 'Angel Fire',
  [DfwCities.Angeot]: 'Angeot',
  [DfwCities.Angleton]: 'Angleton',
  [DfwCities.Anguilla]: 'Anguilla',
  [DfwCities.Angus]: 'Angus',
  [DfwCities.Anna]: 'Anna',
  [DfwCities.AnnaMaria]: 'Anna Maria',
  [DfwCities.Annetta]: 'Annetta',
  [DfwCities.AnnettaNorth]: 'Annetta North',
  [DfwCities.AnnettaSouth]: 'Annetta South',
  [DfwCities.Annona]: 'Annona',
  [DfwCities.Anson]: 'Anson',
  [DfwCities.Anthony]: 'Anthony',
  [DfwCities.Antibes]: 'Antibes',
  [DfwCities.AntiguoCuscaltan]: 'Antiguo Cuscaltan',
  [DfwCities.Anton]: 'Anton',
  [DfwCities.Appleby]: 'Appleby',
  [DfwCities.Aquilla]: 'Aquilla',
  [DfwCities.AransasPass]: 'Aransas Pass',
  [DfwCities.ArcherCity]: 'Archer City',
  [DfwCities.Arcola]: 'Arcola',
  [DfwCities.Ardmore]: 'Ardmore',
  [DfwCities.Arecibo]: 'Arecibo',
  [DfwCities.Argyle]: 'Argyle',
  [DfwCities.Arkoma]: 'Arkoma',
  [DfwCities.Arles]: 'Arles',
  [DfwCities.Arlington]: 'Arlington',
  [DfwCities.Armstrong]: 'Armstrong',
  [DfwCities.Arp]: 'Arp',
  [DfwCities.ArthurCity]: 'Arthur City',
  [DfwCities.Asheville]: 'Asheville',
  [DfwCities.Ashland]: 'Ashland',
  [DfwCities.Aspermont]: 'Aspermont',
  [DfwCities.Atascosa]: 'Atascosa',
  [DfwCities.Athens]: 'Athens',
  [DfwCities.Atlanta]: 'Atlanta',
  [DfwCities.Atoka]: 'Atoka',
  [DfwCities.Aubrey]: 'Aubrey',
  [DfwCities.Aurora]: 'Aurora',
  [DfwCities.Austin]: 'Austin',
  [DfwCities.Austwell]: 'Austwell',
  [DfwCities.AvaillessurSeiche]: 'Availles-sur-Seiche',
  [DfwCities.Avalon]: 'Avalon',
  [DfwCities.Avant]: 'Avant',
  [DfwCities.Avery]: 'Avery',
  [DfwCities.Avignon]: 'Avignon',
  [DfwCities.Avilla]: 'Avilla',
  [DfwCities.Avinger]: 'Avinger',
  [DfwCities.Axtell]: 'Axtell',
  [DfwCities.Azle]: 'Azle',
  [DfwCities.Bagnols]: 'Bagnols',
  [DfwCities.Bagwell]: 'Bagwell',
  [DfwCities.Bailey]: 'Bailey',
  [DfwCities.BaileysPrairie]: 'Baileys Prairie',
  [DfwCities.Baird]: 'Baird',
  [DfwCities.BalchSprings]: 'Balch Springs',
  [DfwCities.BalconesHeights]: 'Balcones Heights',
  [DfwCities.Balfour]: 'Balfour',
  [DfwCities.Bali]: 'Bali',
  [DfwCities.Ballinger]: 'Ballinger',
  [DfwCities.Balmorhea]: 'Balmorhea',
  [DfwCities.Bandera]: 'Bandera',
  [DfwCities.Bangs]: 'Bangs',
  [DfwCities.Banquete]: 'Banquete',
  [DfwCities.Barcelona]: 'Barcelona',
  [DfwCities.Bardwell]: 'Bardwell',
  [DfwCities.Barling]: 'Barling',
  [DfwCities.Barry]: 'Barry',
  [DfwCities.Barstow]: 'Barstow',
  [DfwCities.Bartlett]: 'Bartlett',
  [DfwCities.Bartonville]: 'Bartonville',
  [DfwCities.Bastrop]: 'Bastrop',
  [DfwCities.Batonrouge]: 'Batonrouge',
  [DfwCities.Battiest]: 'Battiest',
  [DfwCities.Bauxite]: 'Bauxite',
  [DfwCities.Bay]: 'Bay',
  [DfwCities.BayCity]: 'Bay City',
  [DfwCities.BayouVista]: 'Bayou Vista',
  [DfwCities.Bayside]: 'Bayside',
  [DfwCities.Baytown]: 'Baytown',
  [DfwCities.Beach]: 'Beach',
  [DfwCities.Bear]: 'Bear',
  [DfwCities.BearCreek]: 'Bear Creek',
  [DfwCities.Beasley]: 'Beasley',
  [DfwCities.Beaumont]: 'Beaumont',
  [DfwCities.Beckville]: 'Beckville',
  [DfwCities.Bedford]: 'Bedford',
  [DfwCities.Bee]: 'Bee',
  [DfwCities.BeeCave]: 'Bee Cave',
  [DfwCities.Beeville]: 'Beeville',
  [DfwCities.Belfalls]: 'Belfalls',
  [DfwCities.Belgrade]: 'Belgrade',
  [DfwCities.Belize]: 'Belize',
  [DfwCities.BellaVista]: 'Bella Vista',
  [DfwCities.Bellaire]: 'Bellaire',
  [DfwCities.Bellevue]: 'Bellevue',
  [DfwCities.Bellmead]: 'Bellmead',
  [DfwCities.Bells]: 'Bells',
  [DfwCities.Bellville]: 'Bellville',
  [DfwCities.Belton]: 'Belton',
  [DfwCities.BenFranklin]: 'Ben Franklin',
  [DfwCities.BenWheeler]: 'Ben Wheeler',
  [DfwCities.Benavides]: 'Benavides',
  [DfwCities.Benbrook]: 'Benbrook',
  [DfwCities.Benchley]: 'Benchley',
  [DfwCities.Bend]: 'Bend',
  [DfwCities.Benjamin]: 'Benjamin',
  [DfwCities.Bennington]: 'Bennington',
  [DfwCities.Benton]: 'Benton',
  [DfwCities.Bentonville]: 'Bentonville',
  [DfwCities.Berea]: 'Berea',
  [DfwCities.Berlin]: 'Berlin',
  [DfwCities.Berryville]: 'Berryville',
  [DfwCities.Bertram]: 'Bertram',
  [DfwCities.Bethel]: 'Bethel',
  [DfwCities.BethelHeights]: 'Bethel Heights',
  [DfwCities.BeverlyHills]: 'Beverly Hills',
  [DfwCities.BevilOaks]: 'Bevil Oaks',
  [DfwCities.Beziers]: 'Beziers',
  [DfwCities.BigLake]: 'Big Lake',
  [DfwCities.BigSandy]: 'Big Sandy',
  [DfwCities.BigSpring]: 'Big Spring',
  [DfwCities.Birome]: 'Birome',
  [DfwCities.Birthright]: 'Birthright',
  [DfwCities.Bishop]: 'Bishop',
  [DfwCities.BishopHills]: 'Bishop Hills',
  [DfwCities.Bismarck]: 'Bismarck',
  [DfwCities.Bivins]: 'Bivins',
  [DfwCities.Blacksburg]: 'Blacksburg',
  [DfwCities.Blackwell]: 'Blackwell',
  [DfwCities.Blainville]: 'Blainville',
  [DfwCities.Blakely]: 'Blakely',
  [DfwCities.Blanco]: 'Blanco',
  [DfwCities.Bland]: 'Bland',
  [DfwCities.Blanket]: 'Blanket',
  [DfwCities.Blessing]: 'Blessing',
  [DfwCities.Bloomburg]: 'Bloomburg',
  [DfwCities.BloomingGrove]: 'Blooming Grove',
  [DfwCities.Blossom]: 'Blossom',
  [DfwCities.Blue]: 'Blue',
  [DfwCities.BlueMound]: 'Blue Mound',
  [DfwCities.BlueRidge]: 'Blue Ridge',
  [DfwCities.BlueSprings]: 'Blue Springs',
  [DfwCities.Bluegrove]: 'Bluegrove',
  [DfwCities.BluffDale]: 'Bluff Dale',
  [DfwCities.Bluffton]: 'Bluffton',
  [DfwCities.Blum]: 'Blum',
  [DfwCities.Blythe]: 'Blythe',
  [DfwCities.Boerne]: 'Boerne',
  [DfwCities.Bogata]: 'Bogata',
  [DfwCities.Bokchito]: 'Bokchito',
  [DfwCities.Bokhoma]: 'Bokhoma',
  [DfwCities.Bolivar]: 'Bolivar',
  [DfwCities.Bonham]: 'Bonham',
  [DfwCities.BonitaSprings]: 'Bonita Springs',
  [DfwCities.Bonnerdale]: 'Bonnerdale',
  [DfwCities.Bonney]: 'Bonney',
  [DfwCities.Booker]: 'Booker',
  [DfwCities.Booneville]: 'Booneville',
  [DfwCities.Boonsville]: 'Boonsville',
  [DfwCities.Bordeaux]: 'Bordeaux',
  [DfwCities.Boswell]: 'Boswell',
  [DfwCities.Bovina]: 'Bovina',
  [DfwCities.Bowie]: 'Bowie',
  [DfwCities.Boyce]: 'Boyce',
  [DfwCities.Boyd]: 'Boyd',
  [DfwCities.Bozeman]: 'Bozeman',
  [DfwCities.Brackettville]: 'Brackettville',
  [DfwCities.Brad]: 'Brad',
  [DfwCities.Bradshaw]: 'Bradshaw',
  [DfwCities.Brady]: 'Brady',
  [DfwCities.Branch]: 'Branch',
  [DfwCities.Brandon]: 'Brandon',
  [DfwCities.Brashear]: 'Brashear',
  [DfwCities.Brazoria]: 'Brazoria',
  [DfwCities.Brazos]: 'Brazos',
  [DfwCities.Breckenridge]: 'Breckenridge',
  [DfwCities.Bremond]: 'Bremond',
  [DfwCities.Brenham]: 'Brenham',
  [DfwCities.Briarcliff]: 'Briarcliff',
  [DfwCities.Briaroaks]: 'Briaroaks',
  [DfwCities.Bridge]: 'Bridge',
  [DfwCities.Bridgeport]: 'Bridgeport',
  [DfwCities.Briggs]: 'Briggs',
  [DfwCities.Briscoe]: 'Briscoe',
  [DfwCities.Bristol]: 'Bristol',
  [DfwCities.Broaddus]: 'Broaddus',
  [DfwCities.Brock]: 'Brock',
  [DfwCities.BrokenBow]: 'Broken Bow',
  [DfwCities.Bromide]: 'Bromide',
  [DfwCities.Bronte]: 'Bronte',
  [DfwCities.Brookesmith]: 'Brookesmith',
  [DfwCities.Brookshire]: 'Brookshire',
  [DfwCities.Brookside]: 'Brookside',
  [DfwCities.Brookston]: 'Brookston',
  [DfwCities.Browndell]: 'Browndell',
  [DfwCities.Brownfield]: 'Brownfield',
  [DfwCities.Brownsboro]: 'Brownsboro',
  [DfwCities.Brownsville]: 'Brownsville',
  [DfwCities.Brownwood]: 'Brownwood',
  [DfwCities.BrucevilleEddy]: 'Bruceville Eddy',
  [DfwCities.Brunswick]: 'Brunswick',
  [DfwCities.Bryan]: 'Bryan',
  [DfwCities.Bryant]: 'Bryant',
  [DfwCities.Bryson]: 'Bryson',
  [DfwCities.BuchananDam]: 'Buchanan Dam',
  [DfwCities.Buckholts]: 'Buckholts',
  [DfwCities.Buckingham]: 'Buckingham',
  [DfwCities.Buda]: 'Buda',
  [DfwCities.Buffalo]: 'Buffalo',
  [DfwCities.BuffaloGap]: 'Buffalo Gap',
  [DfwCities.BugTusle]: 'Bug Tusle',
  [DfwCities.BullShoals]: 'Bull Shoals',
  [DfwCities.Bullard]: 'Bullard',
  [DfwCities.Bulverde]: 'Bulverde',
  [DfwCities.Buna]: 'Buna',
  [DfwCities.BunkerHillVillage]: 'Bunker Hill Village',
  [DfwCities.Bunyan]: 'Bunyan',
  [DfwCities.Burkburnett]: 'Burkburnett',
  [DfwCities.Burke]: 'Burke',
  [DfwCities.Burkett]: 'Burkett',
  [DfwCities.Burkeville]: 'Burkeville',
  [DfwCities.Burleson]: 'Burleson',
  [DfwCities.Burlington]: 'Burlington',
  [DfwCities.Burnet]: 'Burnet',
  [DfwCities.Burneyville]: 'Burneyville',
  [DfwCities.BurnsFlat]: 'Burns Flat',
  [DfwCities.Burton]: 'Burton',
  [DfwCities.Butterfield]: 'Butterfield',
  [DfwCities.Byers]: 'Byers',
  [DfwCities.Byng]: 'Byng',
  [DfwCities.Bynum]: 'Bynum',
  [DfwCities.Cabarete]: 'Cabarete',
  [DfwCities.CaboSanLucas]: 'Cabo San Lucas',
  [DfwCities.Cactus]: 'Cactus',
  [DfwCities.Caddo]: 'Caddo',
  [DfwCities.CaddoMills]: 'Caddo Mills',
  [DfwCities.Caen]: 'Caen',
  [DfwCities.Caldwell]: 'Caldwell',
  [DfwCities.Calera]: 'Calera',
  [DfwCities.Callisburg]: 'Callisburg',
  [DfwCities.Caloocan]: 'Caloocan',
  [DfwCities.Calvert]: 'Calvert',
  [DfwCities.Cameron]: 'Cameron',
  [DfwCities.CampWood]: 'Camp Wood',
  [DfwCities.Campbell]: 'Campbell',
  [DfwCities.Canadian]: 'Canadian',
  [DfwCities.Cancun]: 'Cancun',
  [DfwCities.Caney]: 'Caney',
  [DfwCities.CaneyCity]: 'Caney City',
  [DfwCities.Cannes]: 'Cannes',
  [DfwCities.CanonCity]: 'Canon City',
  [DfwCities.Canton]: 'Canton',
  [DfwCities.Canutillo]: 'Canutillo',
  [DfwCities.Canyon]: 'Canyon',
  [DfwCities.CanyonLake]: 'Canyon Lake',
  [DfwCities.Capitola]: 'Capitola',
  [DfwCities.CappsCorner]: 'Capps Corner',
  [DfwCities.Caradan]: 'Caradan',
  [DfwCities.Carbon]: 'Carbon',
  [DfwCities.CarlsCorner]: 'Carls Corner',
  [DfwCities.Carlsbad]: 'Carlsbad',
  [DfwCities.Carlton]: 'Carlton',
  [DfwCities.Carmel]: 'Carmel',
  [DfwCities.Carmine]: 'Carmine',
  [DfwCities.CarolinaBeach]: 'Carolina Beach',
  [DfwCities.Carpenter]: 'Carpenter',
  [DfwCities.Carrabelle]: 'Carrabelle',
  [DfwCities.Carrollton]: 'Carrollton',
  [DfwCities.Carson]: 'Carson',
  [DfwCities.Cartago]: 'Cartago',
  [DfwCities.Carthage]: 'Carthage',
  [DfwCities.Cartwright]: 'Cartwright',
  [DfwCities.Cash]: 'Cash',
  [DfwCities.Cason]: 'Cason',
  [DfwCities.Castell]: 'Castell',
  [DfwCities.CastiglionFiorentino]: 'Castiglion Fiorentino',
  [DfwCities.CastleHills]: 'Castle Hills',
  [DfwCities.Castries]: 'Castries',
  [DfwCities.Castroville]: 'Castroville',
  [DfwCities.CaveSprings]: 'Cave Springs',
  [DfwCities.Cayuga]: 'Cayuga',
  [DfwCities.CebuCity]: 'Cebu City',
  [DfwCities.CedarCreek]: 'Cedar Creek',
  [DfwCities.CedarCreekLake]: 'Cedar Creek Lake',
  [DfwCities.CedarHill]: 'Cedar Hill',
  [DfwCities.CedarLane]: 'Cedar Lane',
  [DfwCities.CedarPark]: 'Cedar Park',
  [DfwCities.Celeste]: 'Celeste',
  [DfwCities.Celina]: 'Celina',
  [DfwCities.Celles]: 'Celles',
  [DfwCities.Center]: 'Center',
  [DfwCities.CenterCity]: 'Center City',
  [DfwCities.Centerton]: 'Centerton',
  [DfwCities.Centerville]: 'Centerville',
  [DfwCities.CentralCity]: 'Central City',
  [DfwCities.ChacteauneufduPape]: 'ChÃ¢teauneuf-du-Pape',
  [DfwCities.Chandler]: 'Chandler',
  [DfwCities.Channing]: 'Channing',
  [DfwCities.ChapmanRanch]: 'Chapman Ranch',
  [DfwCities.ChappellHill]: 'Chappell Hill',
  [DfwCities.Charleston]: 'Charleston',
  [DfwCities.Charlotte]: 'Charlotte',
  [DfwCities.Chatfield]: 'Chatfield',
  [DfwCities.Chatham]: 'Chatham',
  [DfwCities.Cheney]: 'Cheney',
  [DfwCities.Cherokee]: 'Cherokee',
  [DfwCities.Chester]: 'Chester',
  [DfwCities.Chetumal]: 'Chetumal',
  [DfwCities.Cheyenne]: 'Cheyenne',
  [DfwCities.Chicago]: 'Chicago',
  [DfwCities.Chico]: 'Chico',
  [DfwCities.Chicota]: 'Chicota',
  [DfwCities.Childress]: 'Childress',
  [DfwCities.Chillicothe]: 'Chillicothe',
  [DfwCities.Chilton]: 'Chilton',
  [DfwCities.China]: 'China',
  [DfwCities.ChinaGrove]: 'China Grove',
  [DfwCities.ChinaSpring]: 'China Spring',
  [DfwCities.Chinandega]: 'Chinandega',
  [DfwCities.Chireno]: 'Chireno',
  [DfwCities.Chriesman]: 'Chriesman',
  [DfwCities.Christiansburg]: 'Christiansburg',
  [DfwCities.Christine]: 'Christine',
  [DfwCities.Christoval]: 'Christoval',
  [DfwCities.Cibolo]: 'Cibolo',
  [DfwCities.Cisco]: 'Cisco',
  [DfwCities.Clairette]: 'Clairette',
  [DfwCities.Clarendon]: 'Clarendon',
  [DfwCities.Clark]: 'Clark',
  [DfwCities.Clarksville]: 'Clarksville  ',
  [DfwCities.Claude]: 'Claude',
  [DfwCities.Clay]: 'Clay',
  [DfwCities.Clayton]: 'Clayton',
  [DfwCities.ClearLakeShores]: 'Clear Lake Shores',
  [DfwCities.Clearwater]: 'Clearwater',
  [DfwCities.Cleburne]: 'Cleburne',
  [DfwCities.Cleveland]: 'Cleveland',
  [DfwCities.Clifton]: 'Clifton',
  [DfwCities.Clint]: 'Clint',
  [DfwCities.Clinton]: 'Clinton',
  [DfwCities.Clute]: 'Clute',
  [DfwCities.Clyde]: 'Clyde',
  [DfwCities.Coahoma]: 'Coahoma',
  [DfwCities.CockrellHill]: 'Cockrell Hill',
  [DfwCities.Coffee]: 'Coffee',
  [DfwCities.CoffeeCity]: 'Coffee City',
  [DfwCities.Cojutepeque]: 'Cojutepeque',
  [DfwCities.Colbert]: 'Colbert',
  [DfwCities.ColdSpring]: 'Cold Spring',
  [DfwCities.Coldspring]: 'Coldspring',
  [DfwCities.Coleman]: 'Coleman',
  [DfwCities.CollegeStation]: 'College Station',
  [DfwCities.Collegeport]: 'Collegeport',
  [DfwCities.Colleyville]: 'Colleyville',
  [DfwCities.Collinsville]: 'Collinsville',
  [DfwCities.Colmesneil]: 'Colmesneil',
  [DfwCities.Colorado]: 'Colorado',
  [DfwCities.ColoradoCity]: 'Colorado City',
  [DfwCities.Columbus]: 'Columbus',
  [DfwCities.Comanche]: 'Comanche',
  [DfwCities.Combes]: 'Combes',
  [DfwCities.Combine]: 'Combine',
  [DfwCities.Comfort]: 'Comfort',
  [DfwCities.Commerce]: 'Commerce',
  [DfwCities.Como]: 'Como',
  [DfwCities.Concord]: 'Concord',
  [DfwCities.Congo]: 'Congo',
  [DfwCities.Connerville]: 'Connerville',
  [DfwCities.Conroe]: 'Conroe',
  [DfwCities.Converse]: 'Converse',
  [DfwCities.Conway]: 'Conway',
  [DfwCities.Cookville]: 'Cookville',
  [DfwCities.Cool]: 'Cool',
  [DfwCities.Coolidge]: 'Coolidge',
  [DfwCities.Cooper]: 'Cooper',
  [DfwCities.Copeville]: 'Copeville',
  [DfwCities.Coppell]: 'Coppell',
  [DfwCities.CopperCanyon]: 'Copper Canyon',
  [DfwCities.CopperasCove]: 'Copperas Cove',
  [DfwCities.Cordell]: 'Cordell',
  [DfwCities.Corinth]: 'Corinth',
  [DfwCities.Corozal]: 'Corozal',
  [DfwCities.CorpusChristi]: 'Corpus Christi',
  [DfwCities.CorralCity]: 'Corral City',
  [DfwCities.Corrigan]: 'Corrigan',
  [DfwCities.Corsicana]: 'Corsicana',
  [DfwCities.Cortona]: 'Cortona',
  [DfwCities.CostadelEste]: 'Costa del Este',
  [DfwCities.CostaRica]: 'Costa Rica',
  [DfwCities.Cotter]: 'Cotter',
  [DfwCities.CottonCenter]: 'Cotton Center',
  [DfwCities.Cottonwood]: 'Cottonwood',
  [DfwCities.CottonwoodShores]: 'Cottonwood Shores',
  [DfwCities.Cotulla]: 'Cotulla',
  [DfwCities.Coupland]: 'Coupland',
  [DfwCities.Courtney]: 'Courtney',
  [DfwCities.Cove]: 'Cove',
  [DfwCities.Covington]: 'Covington',
  [DfwCities.Crandall]: 'Crandall',
  [DfwCities.Crane]: 'Crane',
  [DfwCities.CranfillsGap]: 'Cranfills Gap',
  [DfwCities.Crawford]: 'Crawford',
  [DfwCities.Creedmoor]: 'Creedmoor',
  [DfwCities.Cresson]: 'Cresson',
  [DfwCities.CrestedButte]: 'Crested Butte',
  [DfwCities.Crockett]: 'Crockett',
  [DfwCities.Crosbyton]: 'Crosbyton',
  [DfwCities.CrossCut]: 'Cross Cut',
  [DfwCities.CrossPlains]: 'Cross Plains',
  [DfwCities.CrossRoads]: 'Cross Roads',
  [DfwCities.CrossTimber]: 'Cross Timber',
  [DfwCities.Crossville]: 'Crossville',
  [DfwCities.Crowell]: 'Crowell',
  [DfwCities.Crowley]: 'Crowley',
  [DfwCities.Crows]: 'Crows',
  [DfwCities.Crystal]: 'Crystal',
  [DfwCities.CrystalBeach]: 'Crystal Beach',
  [DfwCities.CrystalSprings]: 'Crystal Springs',
  [DfwCities.Cuero]: 'Cuero',
  [DfwCities.Cumby]: 'Cumby',
  [DfwCities.Cuney]: 'Cuney',
  [DfwCities.Cunningham]: 'Cunningham',
  [DfwCities.Cushing]: 'Cushing',
  [DfwCities.CutandShoot]: 'Cut and Shoot',
  [DfwCities.DHanis]: 'D Hanis',
  [DfwCities.Daingerfield]: 'Daingerfield',
  [DfwCities.Daisetta]: 'Daisetta',
  [DfwCities.Dalhart]: 'Dalhart',
  [DfwCities.Dallas]: 'Dallas',
  [DfwCities.Dalton]: 'Dalton',
  [DfwCities.DalworthingtonGardens]: 'Dalworthington Gardens',
  [DfwCities.Danbury]: 'Danbury',
  [DfwCities.Danner]: 'Danner',
  [DfwCities.Dardanelle]: 'Dardanelle',
  [DfwCities.Darrouzett]: 'Darrouzett',
  [DfwCities.Dawson]: 'Dawson',
  [DfwCities.Dayton]: 'Dayton',
  [DfwCities.DaytonLakes]: 'Dayton Lakes',
  [DfwCities.DeBerry]: 'De Berry',
  [DfwCities.DeCordova]: 'De Cordova',
  [DfwCities.DeKalb]: 'De Kalb',
  [DfwCities.DeLeon]: 'De Leon',
  [DfwCities.Dean]: 'Dean',
  [DfwCities.Deanville]: 'Deanville',
  [DfwCities.Decatur]: 'Decatur',
  [DfwCities.DeerPark]: 'Deer Park',
  [DfwCities.DelRio]: 'Del Rio',
  [DfwCities.DelValle]: 'Del Valle',
  [DfwCities.Dell]: 'Dell',
  [DfwCities.Denison]: 'Denison',
  [DfwCities.Dennis]: 'Dennis',
  [DfwCities.Denton]: 'Denton',
  [DfwCities.DENTONVALLEY]: 'DENTON VALLEY',
  [DfwCities.Denver]: 'Denver',
  [DfwCities.Deport]: 'Deport',
  [DfwCities.Derby]: 'Derby',
  [DfwCities.DesArc]: 'Des Arc',
  [DfwCities.Desdemona]: 'Desdemona',
  [DfwCities.DeSoto]: 'DeSoto',
  [DfwCities.Detroit]: 'Detroit',
  [DfwCities.Devers]: 'Devers',
  [DfwCities.Devine]: 'Devine',
  [DfwCities.Devol]: 'Devol',
  [DfwCities.Dew]: 'Dew',
  [DfwCities.DiamondHead]: 'Diamond Head',
  [DfwCities.Diana]: 'Diana',
  [DfwCities.Diboll]: 'Diboll',
  [DfwCities.Dickens]: 'Dickens',
  [DfwCities.Dickinson]: 'Dickinson',
  [DfwCities.Dike]: 'Dike',
  [DfwCities.DillCity]: 'Dill City',
  [DfwCities.Dilley]: 'Dilley',
  [DfwCities.Dimmitt]: 'Dimmitt',
  [DfwCities.Dinero]: 'Dinero',
  [DfwCities.Dish]: 'Dish',
  [DfwCities.Divide]: 'Divide',
  [DfwCities.DoddCity]: 'Dodd City',
  [DfwCities.Dodson]: 'Dodson',
  [DfwCities.Domino]: 'Domino',
  [DfwCities.Donie]: 'Donie',
  [DfwCities.Donna]: 'Donna',
  [DfwCities.Doole]: 'Doole',
  [DfwCities.Dorchester]: 'Dorchester',
  [DfwCities.Doss]: 'Doss',
  [DfwCities.Dothan]: 'Dothan',
  [DfwCities.DoubleOak]: 'Double Oak',
  [DfwCities.Douglass]: 'Douglass',
  [DfwCities.Douglassville]: 'Douglassville',
  [DfwCities.DoveCreek]: 'Dove Creek',
  [DfwCities.Draguignan]: 'Draguignan',
  [DfwCities.Driftwood]: 'Driftwood',
  [DfwCities.DrippingSprings]: 'Dripping Springs',
  [DfwCities.Driscoll]: 'Driscoll',
  [DfwCities.Dublin]: 'Dublin',
  [DfwCities.Dudley]: 'Dudley',
  [DfwCities.Duffau]: 'Duffau',
  [DfwCities.Dumas]: 'Dumas',
  [DfwCities.Duncan]: 'Duncan',
  [DfwCities.Duncanville]: 'Duncanville',
  [DfwCities.Dunlap]: 'Dunlap',
  [DfwCities.Dunn]: 'Dunn',
  [DfwCities.Duplex]: 'Duplex',
  [DfwCities.Durant]: 'Durant',
  [DfwCities.Durban]: 'Durban',
  [DfwCities.Durham]: 'Durham',
  [DfwCities.EagleLake]: 'Eagle Lake',
  [DfwCities.EagleNest]: 'Eagle Nest',
  [DfwCities.EaglePass]: 'Eagle Pass',
  [DfwCities.Eagletown]: 'Eagletown',
  [DfwCities.Eagltown]: 'Eagltown',
  [DfwCities.Early]: 'Early',
  [DfwCities.Earth]: 'Earth',
  [DfwCities.EastEnd]: 'East End',
  [DfwCities.EastMountain]: 'East Mountain',
  [DfwCities.EastTawakoni]: 'East Tawakoni',
  [DfwCities.Easterly]: 'Easterly',
  [DfwCities.Eastland]: 'Eastland',
  [DfwCities.Easton]: 'Easton',
  [DfwCities.Ebony]: 'Ebony',
  [DfwCities.Ecleto]: 'Ecleto',
  [DfwCities.Ector]: 'Ector',
  [DfwCities.Edcouch]: 'Edcouch',
  [DfwCities.Eden]: 'Eden',
  [DfwCities.EdgecliffVillage]: 'Edgecliff Village',
  [DfwCities.Edgewood]: 'Edgewood',
  [DfwCities.Edinburg]: 'Edinburg',
  [DfwCities.EdmonAlberta]: 'Edmon-Alberta',
  [DfwCities.Edmonson]: 'Edmonson',
  [DfwCities.Edna]: 'Edna',
  [DfwCities.Edom]: 'Edom',
  [DfwCities.ElCampo]: 'El Campo',
  [DfwCities.ElCenizo]: 'El Cenizo',
  [DfwCities.ElIndio]: 'El Indio',
  [DfwCities.ElLago]: 'El Lago',
  [DfwCities.ElPaso]: 'El Paso',
  [DfwCities.ElVendrell]: 'El Vendrell',
  [DfwCities.Eldorado]: 'Eldorado',
  [DfwCities.Electra]: 'Electra',
  [DfwCities.Eleuthera]: 'Eleuthera',
  [DfwCities.Elgin]: 'Elgin',
  [DfwCities.ElkCity]: 'Elk City',
  [DfwCities.Elkhart]: 'Elkhart',
  [DfwCities.Elkins]: 'Elkins',
  [DfwCities.Ellicott]: 'Ellicott',
  [DfwCities.ElmGrove]: 'Elm Grove',
  [DfwCities.ElmMott]: 'Elm Mott',
  [DfwCities.Elmaton]: 'Elmaton',
  [DfwCities.Elmendorf]: 'Elmendorf',
  [DfwCities.Elmo]: 'Elmo',
  [DfwCities.Elsa]: 'Elsa',
  [DfwCities.Elwood]: 'Elwood',
  [DfwCities.ElysianFields]: 'Elysian Fields',
  [DfwCities.Emhouse]: 'Emhouse',
  [DfwCities.Emory]: 'Emory',
  [DfwCities.EnchantedOaks]: 'Enchanted Oaks',
  [DfwCities.Encinal]: 'Encinal',
  [DfwCities.Energy]: 'Energy',
  [DfwCities.Enet]: 'Enet',
  [DfwCities.Enloe]: 'Enloe',
  [DfwCities.Ennis]: 'Ennis',
  [DfwCities.Era]: 'Era',
  [DfwCities.Estancia]: 'Estancia',
  [DfwCities.Estelline]: 'Estelline',
  [DfwCities.Etoile]: 'Etoile',
  [DfwCities.Eula]: 'Eula',
  [DfwCities.Euless]: 'Euless',
  [DfwCities.Eureka]: 'Eureka',
  [DfwCities.Eustace]: 'Eustace',
  [DfwCities.Evadale]: 'Evadale',
  [DfwCities.Evansville]: 'Evansville',
  [DfwCities.Evant]: 'Evant',
  [DfwCities.Everman]: 'Everman',
  [DfwCities.Evres]: 'Evres',
  [DfwCities.Fabens]: 'Fabens',
  [DfwCities.FairOaksRanch]: 'Fair Oaks Ranch',
  [DfwCities.Fairchilds]: 'Fairchilds',
  [DfwCities.Fairfield]: 'Fairfield',
  [DfwCities.Fairlie]: 'Fairlie',
  [DfwCities.Fairview]: 'Fairview',
  [DfwCities.Fairy]: 'Fairy',
  [DfwCities.Falcon]: 'Falcon',
  [DfwCities.Falfurrias]: 'Falfurrias',
  [DfwCities.Falls]: 'Falls',
  [DfwCities.FarmersBranch]: 'Farmers Branch',
  [DfwCities.Farmersville]: 'Farmersville',
  [DfwCities.Farmington]: 'Farmington',
  [DfwCities.Farwell]: 'Farwell',
  [DfwCities.Fate]: 'Fate',
  [DfwCities.Fayetteville]: 'Fayetteville',
  [DfwCities.Felker]: 'Felker',
  [DfwCities.Ferris]: 'Ferris',
  [DfwCities.Filmore]: 'Filmore',
  [DfwCities.Fischer]: 'Fischer',
  [DfwCities.Fisk]: 'Fisk',
  [DfwCities.Fittstown]: 'Fittstown',
  [DfwCities.Fitzhugh]: 'Fitzhugh',
  [DfwCities.Flat]: 'Flat',
  [DfwCities.Flatonia]: 'Flatonia',
  [DfwCities.Flint]: 'Flint',
  [DfwCities.Flippin]: 'Flippin',
  [DfwCities.Flora]: 'Flora',
  [DfwCities.Florence]: 'Florence',
  [DfwCities.Floresville]: 'Floresville',
  [DfwCities.FlowerMound]: 'Flower Mound',
  [DfwCities.Floyd]: 'Floyd',
  [DfwCities.Floydada]: 'Floydada',
  [DfwCities.Fluvanna]: 'Fluvanna',
  [DfwCities.Flynn]: 'Flynn',
  [DfwCities.Fob]: 'Fob',
  [DfwCities.Follett]: 'Follett',
  [DfwCities.Forest]: 'Forest',
  [DfwCities.ForestHill]: 'Forest Hill',
  [DfwCities.Forestburg]: 'Forestburg',
  [DfwCities.Forney]: 'Forney',
  [DfwCities.Forreston]: 'Forreston',
  [DfwCities.Forsan]: 'Forsan',
  [DfwCities.FortGibson]: 'Fort Gibson',
  [DfwCities.FortPayne]: 'Fort Payne',
  [DfwCities.FortSmith]: 'Fort Smith',
  [DfwCities.FortStockton]: 'Fort Stockton',
  [DfwCities.FortTowson]: 'Fort Towson',
  [DfwCities.FortWorth]: 'Fort Worth',
  [DfwCities.FountainLake]: 'Fountain Lake',
  [DfwCities.Francis]: 'Francis',
  [DfwCities.Franklin]: 'Franklin',
  [DfwCities.Frankston]: 'Frankston',
  [DfwCities.Fredericksburg]: 'Fredericksburg',
  [DfwCities.Freeport]: 'Freeport',
  [DfwCities.Freer]: 'Freer',
  [DfwCities.Friendship]: 'Friendship',
  [DfwCities.Friendswood]: 'Friendswood',
  [DfwCities.Friona]: 'Friona',
  [DfwCities.Frisco]: 'Frisco',
  [DfwCities.Fritch]: 'Fritch',
  [DfwCities.Frogville]: 'Frogville',
  [DfwCities.Frost]: 'Frost',
  [DfwCities.Fruitvale]: 'Fruitvale',
  [DfwCities.Fulshear]: 'Fulshear',
  [DfwCities.Fulton]: 'Fulton',
  [DfwCities.Funston]: 'Funston',
  [DfwCities.Gail]: 'Gail',
  [DfwCities.Gainesville]: 'Gainesville',
  [DfwCities.GalenaPark]: 'Galena Park',
  [DfwCities.Gallatin]: 'Gallatin',
  [DfwCities.GallatinGateway]: 'Gallatin Gateway',
  [DfwCities.Galveston]: 'Galveston',
  [DfwCities.Ganado]: 'Ganado',
  [DfwCities.GardenCity]: 'Garden City',
  [DfwCities.GardenRidge]: 'Garden Ridge',
  [DfwCities.Gardiner]: 'Gardiner',
  [DfwCities.Garland]: 'Garland',
  [DfwCities.Garner]: 'Garner',
  [DfwCities.Garrett]: 'Garrett',
  [DfwCities.Garrison]: 'Garrison',
  [DfwCities.Garvin]: 'Garvin',
  [DfwCities.Gary]: 'Gary',
  [DfwCities.Gatesville]: 'Gatesville',
  [DfwCities.Gause]: 'Gause',
  [DfwCities.Gaybluff]: 'Gaybluff',
  [DfwCities.Geneva]: 'Geneva',
  [DfwCities.GeorgeWest]: 'George West',
  [DfwCities.Georgetown]: 'Georgetown',
  [DfwCities.Geronimo]: 'Geronimo',
  [DfwCities.Gettengruen]: 'Gettengruen',
  [DfwCities.Gholson]: 'Gholson',
  [DfwCities.Giddings]: 'Giddings',
  [DfwCities.Gilbert]: 'Gilbert',
  [DfwCities.Gillett]: 'Gillett',
  [DfwCities.Gilmer]: 'Gilmer',
  [DfwCities.Gladewater]: 'Gladewater',
  [DfwCities.GlenCove]: 'Glen Cove',
  [DfwCities.GlenRose]: 'Glen Rose',
  [DfwCities.GlennHeights]: 'Glenn Heights',
  [DfwCities.Gober]: 'Gober',
  [DfwCities.Godley]: 'Godley',
  [DfwCities.Golden]: 'Golden',
  [DfwCities.Goldsboro]: 'Goldsboro',
  [DfwCities.Goldsmith]: 'Goldsmith',
  [DfwCities.Goldthwaite]: 'Goldthwaite',
  [DfwCities.Goliad]: 'Goliad',
  [DfwCities.Golinda]: 'Golinda',
  [DfwCities.Gonzales]: 'Gonzales',
  [DfwCities.Goodland]: 'Goodland',
  [DfwCities.Goodlow]: 'Goodlow',
  [DfwCities.Goodrich]: 'Goodrich',
  [DfwCities.Gordon]: 'Gordon',
  [DfwCities.Gordonville]: 'Gordonville',
  [DfwCities.Goree]: 'Goree',
  [DfwCities.Gorman]: 'Gorman',
  [DfwCities.Gouldbusk]: 'Gouldbusk',
  [DfwCities.Graford]: 'Graford',
  [DfwCities.Graham]: 'Graham',
  [DfwCities.Granbury]: 'Granbury',
  [DfwCities.GrandCayman]: 'Grand Cayman',
  [DfwCities.GrandJunction]: 'Grand Junction',
  [DfwCities.GrandPrairie]: 'Grand Prairie',
  [DfwCities.GrandSaline]: 'Grand Saline',
  [DfwCities.Grandfalls]: 'Grandfalls',
  [DfwCities.Grandview]: 'Grandview',
  [DfwCities.Granger]: 'Granger',
  [DfwCities.GraniteShoals]: 'Granite Shoals',
  [DfwCities.Granjeno]: 'Granjeno',
  [DfwCities.Grapeland]: 'Grapeland',
  [DfwCities.Grapevine]: 'Grapevine',
  [DfwCities.Gravette]: 'Gravette',
  [DfwCities.GraysPrairie]: 'Grays Prairie',
  [DfwCities.GreatExuma]: 'Great Exuma',
  [DfwCities.Greenview]: 'Greenview',
  [DfwCities.Greenville]: 'Greenville',
  [DfwCities.Greenwood]: 'Greenwood',
  [DfwCities.Gregory]: 'Gregory',
  [DfwCities.GreyForest]: 'Grey Forest',
  [DfwCities.Groesbeck]: 'Groesbeck',
  [DfwCities.Groom]: 'Groom',
  [DfwCities.GrosIslet]: 'Gros Islet',
  [DfwCities.Grosvenor]: 'Grosvenor',
  [DfwCities.Groves]: 'Groves',
  [DfwCities.Groveton]: 'Groveton',
  [DfwCities.Gruver]: 'Gruver',
  [DfwCities.GuatemalaCity]: 'Guatemala City',
  [DfwCities.Guingamp]: 'Guingamp',
  [DfwCities.GunBarrelCity]: 'Gun Barrel City',
  [DfwCities.Gunter]: 'Gunter',
  [DfwCities.Gustine]: 'Gustine',
  [DfwCities.Guthrie]: 'Guthrie',
  [DfwCities.Guttengruen]: 'Guttengruen',
  [DfwCities.Hackberry]: 'Hackberry',
  [DfwCities.Hackett]: 'Hackett',
  [DfwCities.Hagansport]: 'Hagansport',
  [DfwCities.HaleCenter]: 'Hale Center',
  [DfwCities.Hallettsville]: 'Hallettsville',
  [DfwCities.Hallsburg]: 'Hallsburg',
  [DfwCities.Hallsville]: 'Hallsville',
  [DfwCities.HaltomCity]: 'Haltom City',
  [DfwCities.Hamby]: 'Hamby',
  [DfwCities.Hamilton]: 'Hamilton',
  [DfwCities.Hamlin]: 'Hamlin',
  [DfwCities.Hammond]: 'Hammond',
  [DfwCities.Happy]: 'Happy',
  [DfwCities.HappyLand]: 'Happy Land',
  [DfwCities.Harbin]: 'Harbin',
  [DfwCities.HardenCity]: 'Harden City',
  [DfwCities.Hardin]: 'Hardin',
  [DfwCities.HarkerHeights]: 'Harker Heights',
  [DfwCities.Harleton]: 'Harleton',
  [DfwCities.Harlingen]: 'Harlingen',
  [DfwCities.Harper]: 'Harper',
  [DfwCities.Harris]: 'Harris',
  [DfwCities.Harrold]: 'Harrold',
  [DfwCities.Hart]: 'Hart',
  [DfwCities.Hartsel]: 'Hartsel',
  [DfwCities.Haske]: 'Haske',
  [DfwCities.Haskell]: 'Haskell',
  [DfwCities.Haslet]: 'Haslet',
  [DfwCities.Hasse]: 'Hasse',
  [DfwCities.Hatfield]: 'Hatfield',
  [DfwCities.Haughton]: 'Haughton',
  [DfwCities.HawkCove]: 'Hawk Cove',
  [DfwCities.Hawkins]: 'Hawkins',
  [DfwCities.Hawley]: 'Hawley',
  [DfwCities.Hays]: 'Hays',
  [DfwCities.Hearne]: 'Hearne',
  [DfwCities.Heartland]: 'Heartland',
  [DfwCities.Heath]: 'Heath',
  [DfwCities.Heavener]: 'Heavener',
  [DfwCities.Hebron]: 'Hebron',
  [DfwCities.Hebronville]: 'Hebronville',
  [DfwCities.Hedley]: 'Hedley',
  [DfwCities.HedwigVillage]: 'Hedwig Village',
  [DfwCities.Heidenheimer]: 'Heidenheimer',
  [DfwCities.Helena]: 'Helena',
  [DfwCities.Helotes]: 'Helotes',
  [DfwCities.Hemphill]: 'Hemphill',
  [DfwCities.Hempstead]: 'Hempstead',
  [DfwCities.Hempwallace]: 'Hempwallace',
  [DfwCities.Henderson]: 'Henderson',
  [DfwCities.Hendersonville]: 'Hendersonville',
  [DfwCities.Hendrix]: 'Hendrix',
  [DfwCities.Henrietta]: 'Henrietta',
  [DfwCities.Hereford]: 'Hereford',
  [DfwCities.Hermleigh]: 'Hermleigh',
  [DfwCities.HerveyBay]: 'Hervey Bay',
  [DfwCities.Hewitt]: 'Hewitt',
  [DfwCities.HickoryCreek]: 'Hickory Creek',
  [DfwCities.Hico]: 'Hico',
  [DfwCities.Hidalgo]: 'Hidalgo',
  [DfwCities.Hideaway]: 'Hideaway',
  [DfwCities.Higgins]: 'Higgins',
  [DfwCities.HighlandHaven]: 'Highland Haven',
  [DfwCities.HighlandPark]: 'Highland Park',
  [DfwCities.HighlandVillage]: 'Highland Village',
  [DfwCities.HillCountry]: 'Hill Country',
  [DfwCities.Hillcrest]: 'Hillcrest',
  [DfwCities.Hillsboro]: 'Hillsboro',
  [DfwCities.HilshireVillage]: 'Hilshire Village',
  [DfwCities.Hitchcock]: 'Hitchcock',
  [DfwCities.Hobson]: 'Hobson',
  [DfwCities.Hodges]: 'Hodges',
  [DfwCities.HolidayLakes]: 'Holiday Lakes',
  [DfwCities.Holland]: 'Holland',
  [DfwCities.Holliday]: 'Holliday',
  [DfwCities.Hollis]: 'Hollis',
  [DfwCities.HollyLakeRanch]: 'Holly Lake Ranch',
  [DfwCities.HollywoodPark]: 'Hollywood Park',
  [DfwCities.HolmesBeach]: 'Holmes Beach',
  [DfwCities.Homer]: 'Homer',
  [DfwCities.Hondo]: 'Hondo',
  [DfwCities.HoneyGrove]: 'Honey Grove',
  [DfwCities.Hooks]: 'Hooks',
  [DfwCities.Horizon]: 'Horizon',
  [DfwCities.HorseshoeBay]: 'Horseshoe Bay',
  [DfwCities.HotSprings]: 'Hot Springs',
  [DfwCities.HotSpringsVillage]: 'Hot Springs Village',
  [DfwCities.Houston]: 'Houston',
  [DfwCities.Howardwick]: 'Howardwick',
  [DfwCities.Howe]: 'Howe',
  [DfwCities.Hubbard]: 'Hubbard',
  [DfwCities.Huckabay]: 'Huckabay',
  [DfwCities.Hudson]: 'Hudson',
  [DfwCities.HudsonOaks]: 'Hudson Oaks',
  [DfwCities.HughesSprings]: 'Hughes Springs',
  [DfwCities.Hugo]: 'Hugo',
  [DfwCities.Hulen]: 'Hulen',
  [DfwCities.Humacao]: 'Humacao',
  [DfwCities.Humble]: 'Humble',
  [DfwCities.Hunt]: 'Hunt',
  [DfwCities.HuntersCreekVillage]: 'Hunters Creek Village',
  [DfwCities.Huntington]: 'Huntington',
  [DfwCities.Huntsville]: 'Huntsville',
  [DfwCities.Hurst]: 'Hurst',
  [DfwCities.Huskey]: 'Huskey',
  [DfwCities.Hutchins]: 'Hutchins',
  [DfwCities.Hutto]: 'Hutto',
  [DfwCities.Huxley]: 'Huxley',
  [DfwCities.Idabel]: 'Idabel',
  [DfwCities.Idabell]: 'Idabell',
  [DfwCities.Impact]: 'Impact',
  [DfwCities.IndianCreek]: 'Indian Creek',
  [DfwCities.IndianHills]: 'Indian Hills',
  [DfwCities.IndianLake]: 'Indian Lake',
  [DfwCities.Indianapolis]: 'Indianapolis',
  [DfwCities.Industry]: 'Industry',
  [DfwCities.Ingleside]: 'Ingleside',
  [DfwCities.InglesideontheBay]: 'Ingleside on the Bay',
  [DfwCities.Ingram]: 'Ingram',
  [DfwCities.Inverness]: 'Inverness',
  [DfwCities.IowaColony]: 'Iowa Colony',
  [DfwCities.IowaPark]: 'Iowa Park',
  [DfwCities.Ipswich]: 'Ipswich',
  [DfwCities.Ira]: 'Ira',
  [DfwCities.Iraan]: 'Iraan',
  [DfwCities.Iredell]: 'Iredell',
  [DfwCities.Irene]: 'Irene',
  [DfwCities.IronSprings]: 'Iron Springs',
  [DfwCities.Irving]: 'Irving',
  [DfwCities.Italy]: 'Italy',
  [DfwCities.Itasca]: 'Itasca',
  [DfwCities.Ivanhoe]: 'Ivanhoe',
  [DfwCities.Jacinto]: 'Jacinto',
  [DfwCities.Jacksboro]: 'Jacksboro',
  [DfwCities.Jackson]: 'Jackson',
  [DfwCities.Jacksonville]: 'Jacksonville',
  [DfwCities.Jaco]: 'Jaco',
  [DfwCities.JamaicaBeach]: 'Jamaica Beach',
  [DfwCities.Jarrell]: 'Jarrell',
  [DfwCities.Jasper]: 'Jasper',
  [DfwCities.Jayton]: 'Jayton',
  [DfwCities.Jefferson]: 'Jefferson',
  [DfwCities.Jermyn]: 'Jermyn',
  [DfwCities.JerseyVillage]: 'Jersey Village',
  [DfwCities.Jesse]: 'Jesse',
  [DfwCities.Jessieville]: 'Jessieville',
  [DfwCities.Jewett]: 'Jewett',
  [DfwCities.Jimtown]: 'Jimtown',
  [DfwCities.Joaquin]: 'Joaquin',
  [DfwCities.Johnson]: 'Johnson',
  [DfwCities.Joinerville]: 'Joinerville',
  [DfwCities.Jolly]: 'Jolly',
  [DfwCities.Jones]: 'Jones',
  [DfwCities.JonesCreek]: 'Jones Creek',
  [DfwCities.JonesMill]: 'Jones Mill',
  [DfwCities.Jonesboro]: 'Jonesboro',
  [DfwCities.Jonestown]: 'Jonestown',
  [DfwCities.Jonesville]: 'Jonesville',
  [DfwCities.Joplin]: 'Joplin',
  [DfwCities.Josephine]: 'Josephine',
  [DfwCities.Joshua]: 'Joshua',
  [DfwCities.Jourdanton]: 'Jourdanton',
  [DfwCities.Judson]: 'Judson',
  [DfwCities.Junction]: 'Junction',
  [DfwCities.JunctionCity]: 'Junction City',
  [DfwCities.Justin]: 'Justin',
  [DfwCities.Kaiser]: 'Kaiser',
  [DfwCities.Kamay]: 'Kamay',
  [DfwCities.KansasCity]: 'Kansas City',
  [DfwCities.Karnack]: 'Karnack',
  [DfwCities.Karnes]: 'Karnes',
  [DfwCities.KarnesCity]: 'Karnes City',
  [DfwCities.Katy]: 'Katy',
  [DfwCities.Kaufman]: 'Kaufman',
  [DfwCities.Keene]: 'Keene',
  [DfwCities.Keller]: 'Keller',
  [DfwCities.Kemah]: 'Kemah',
  [DfwCities.Kemp]: 'Kemp',
  [DfwCities.Kempner]: 'Kempner',
  [DfwCities.Kendleton]: 'Kendleton',
  [DfwCities.Kenedy]: 'Kenedy',
  [DfwCities.Kenefic]: 'Kenefic',
  [DfwCities.Kenefick]: 'Kenefick',
  [DfwCities.Kennard]: 'Kennard',
  [DfwCities.Kennedale]: 'Kennedale',
  [DfwCities.Kent]: 'Kent',
  [DfwCities.Kentuckytown]: 'Kentuckytown',
  [DfwCities.Kerens]: 'Kerens',
  [DfwCities.Kermit]: 'Kermit',
  [DfwCities.Kerrville]: 'Kerrville',
  [DfwCities.Kiersev]: 'Kiersev',
  [DfwCities.Kildare]: 'Kildare',
  [DfwCities.Kilgore]: 'Kilgore',
  [DfwCities.Killeen]: 'Killeen',
  [DfwCities.Kingsbury]: 'Kingsbury',
  [DfwCities.Kingsland]: 'Kingsland',
  [DfwCities.Kingston]: 'Kingston',
  [DfwCities.Kingsville]: 'Kingsville',
  [DfwCities.Kirby]: 'Kirby',
  [DfwCities.Kirbyville]: 'Kirbyville',
  [DfwCities.Kirvin]: 'Kirvin',
  [DfwCities.Klondike]: 'Klondike',
  [DfwCities.Knollwood]: 'Knollwood',
  [DfwCities.Knox]: 'Knox',
  [DfwCities.KnoxCity]: 'Knox City',
  [DfwCities.Kopperl]: 'Kopperl',
  [DfwCities.Kosse]: 'Kosse',
  [DfwCities.Kountze]: 'Kountze',
  [DfwCities.Kress]: 'Kress',
  [DfwCities.Krugerville]: 'Krugerville',
  [DfwCities.Krum]: 'Krum',
  [DfwCities.Kurten]: 'Kurten',
  [DfwCities.Kyle]: 'Kyle',
  [DfwCities.LaCoste781]: 'La Coste',
  [DfwCities.LaFeria]: 'La Feria',
  [DfwCities.LaGrange]: 'La Grange',
  [DfwCities.LaJoya]: 'La Joya',
  [DfwCities.LaLibertad]: 'La Libertad',
  [DfwCities.LaMarque]: 'La Marque',
  [DfwCities.LaPorte]: 'La Porte',
  [DfwCities.LaRomana]: 'La Romana',
  [DfwCities.LaUnion]: 'La Union',
  [DfwCities.LaVernia]: 'La Vernia',
  [DfwCities.LaVilla]: 'La Villa',
  [DfwCities.LaWard]: 'La Ward',
  [DfwCities.LaCoste790]: 'LaCoste',
  [DfwCities.LacyLakeview]: 'Lacy Lakeview',
  [DfwCities.Ladonia]: 'Ladonia',
  [DfwCities.Lafayette]: 'Lafayette',
  [DfwCities.LagoVista]: 'Lago Vista',
  [DfwCities.LagunaPark]: 'Laguna Park',
  [DfwCities.LagunaVista]: 'Laguna Vista',
  [DfwCities.LairdHill]: 'Laird Hill',
  [DfwCities.Lake]: 'Lake',
  [DfwCities.LakeBridgeport]: 'Lake Bridgeport',
  [DfwCities.LakeBrownwood]: 'Lake Brownwood',
  [DfwCities.LakeCatherine]: 'Lake Catherine',
  [DfwCities.LakeCisco]: 'Lake Cisco',
  [DfwCities.LakeCreek]: 'Lake Creek',
  [DfwCities.LakeDallas]: 'Lake Dallas',
  [DfwCities.LakeHamilton]: 'Lake Hamilton',
  [DfwCities.LakeJackson]: 'Lake Jackson',
  [DfwCities.LakeKiowa]: 'Lake Kiowa',
  [DfwCities.LakeTanglewood]: 'Lake Tanglewood',
  [DfwCities.LakeWorth]: 'Lake Worth',
  [DfwCities.Lakeport]: 'Lakeport',
  [DfwCities.Lakeside]: 'Lakeside',
  [DfwCities.Lakeview]: 'Lakeview',
  [DfwCities.Lakeway]: 'Lakeway',
  [DfwCities.LakewoodRanch]: 'Lakewood Ranch',
  [DfwCities.LakewoodVillage]: 'Lakewood Village',
  [DfwCities.Lamasco]: 'Lamasco',
  [DfwCities.Lamesa]: 'Lamesa',
  [DfwCities.Lampasas]: 'Lampasas',
  [DfwCities.Lanark]: 'Lanark',
  [DfwCities.Lancaster]: 'Lancaster',
  [DfwCities.Laneville]: 'Laneville',
  [DfwCities.Lannius]: 'Lannius',
  [DfwCities.Lansing]: 'Lansing',
  [DfwCities.Lantana]: 'Lantana',
  [DfwCities.LapuLapuCity]: 'Lapu-Lapu City',
  [DfwCities.Laredo]: 'Laredo',
  [DfwCities.Larue]: 'Larue',
  [DfwCities.LasPinas]: 'Las Pinas',
  [DfwCities.LasVegas]: 'Las Vegas',
  [DfwCities.Latexo]: 'Latexo',
  [DfwCities.Latta]: 'Latta',
  [DfwCities.Laurel]: 'Laurel',
  [DfwCities.Lavaca]: 'Lavaca',
  [DfwCities.Lavon]: 'Lavon',
  [DfwCities.Lawn]: 'Lawn',
  [DfwCities.Lawrenceville]: 'Lawrenceville',
  [DfwCities.Layou]: 'Layou',
  [DfwCities.LeMans]: 'Le Mans',
  [DfwCities.League]: 'League',
  [DfwCities.Leakey]: 'Leakey',
  [DfwCities.Leander]: 'Leander',
  [DfwCities.Leary]: 'Leary',
  [DfwCities.Lebanon]: 'Lebanon',
  [DfwCities.Leesburg]: 'Leesburg',
  [DfwCities.Lefors]: 'Lefors',
  [DfwCities.Lenexa]: 'Lenexa',
  [DfwCities.Leon]: 'Leon',
  [DfwCities.LeonJunction]: 'Leon Junction',
  [DfwCities.LeonValley]: 'Leon Valley',
  [DfwCities.Leona]: 'Leona',
  [DfwCities.Leonard]: 'Leonard',
  [DfwCities.Leroy]: 'Leroy',
  [DfwCities.Levelland]: 'Levelland',
  [DfwCities.Lewisville]: 'Lewisville',
  [DfwCities.Lexington]: 'Lexington',
  [DfwCities.Liberty]: 'Liberty',
  [DfwCities.LibertyHill]: 'Liberty Hill',
  [DfwCities.Lillian]: 'Lillian',
  [DfwCities.Lima]: 'Lima',
  [DfwCities.Limoges]: 'Limoges',
  [DfwCities.LincolnPark]: 'Lincoln Park',
  [DfwCities.Lindale]: 'Lindale',
  [DfwCities.Linden]: 'Linden',
  [DfwCities.Lindsay]: 'Lindsay',
  [DfwCities.Lingleville]: 'Lingleville',
  [DfwCities.Lipan]: 'Lipan',
  [DfwCities.LittleCity]: 'Little City',
  [DfwCities.LittleElm]: 'Little Elm',
  [DfwCities.LittleRiver]: 'Little River',
  [DfwCities.LittleRiverAcademy]: 'Little River Academy',
  [DfwCities.LittleRock]: 'Little Rock',
  [DfwCities.Littlefield]: 'Littlefield',
  [DfwCities.LiveOak]: 'Live Oak',
  [DfwCities.Liverpool]: 'Liverpool',
  [DfwCities.Livingston]: 'Livingston',
  [DfwCities.Llano]: 'Llano',
  [DfwCities.Lockhart]: 'Lockhart',
  [DfwCities.Lockney]: 'Lockney',
  [DfwCities.Lodi]: 'Lodi',
  [DfwCities.LogCabin]: 'Log Cabin',
  [DfwCities.Lohn]: 'Lohn',
  [DfwCities.Lolita]: 'Lolita',
  [DfwCities.Lometa]: 'Lometa',
  [DfwCities.London]: 'London',
  [DfwCities.LoneOak]: 'Lone Oak',
  [DfwCities.LoneStar]: 'Lone Star',
  [DfwCities.LongBranch]: 'Long Branch',
  [DfwCities.Longview]: 'Longview',
  [DfwCities.Lono]: 'Lono',
  [DfwCities.Lonsdale]: 'Lonsdale',
  [DfwCities.Loraine]: 'Loraine',
  [DfwCities.Lorena]: 'Lorena',
  [DfwCities.Lorenzo]: 'Lorenzo',
  [DfwCities.Loreto]: 'Loreto',
  [DfwCities.LosFresnos]: 'Los Fresnos',
  [DfwCities.LosIndios]: 'Los Indios',
  [DfwCities.LosYbanez]: 'Los Ybanez',
  [DfwCities.Lott]: 'Lott',
  [DfwCities.Lovelady]: 'Lovelady',
  [DfwCities.Lovell]: 'Lovell',
  [DfwCities.Loving]: 'Loving',
  [DfwCities.Lowell]: 'Lowell',
  [DfwCities.LowryCrossing]: 'Lowry Crossing',
  [DfwCities.LoyalValley]: 'Loyal Valley',
  [DfwCities.Lubbock]: 'Lubbock',
  [DfwCities.Lucas]: 'Lucas',
  [DfwCities.Lueders]: 'Lueders',
  [DfwCities.Luella]: 'Luella',
  [DfwCities.Lufkin]: 'Lufkin',
  [DfwCities.Luling]: 'Luling',
  [DfwCities.Lumberton]: 'Lumberton',
  [DfwCities.Lyford]: 'Lyford',
  [DfwCities.Lyon]: 'Lyon',
  [DfwCities.Lyons]: 'Lyons',
  [DfwCities.Lytle]: 'Lytle',
  [DfwCities.Mabank]: 'Mabank',
  [DfwCities.Macdona]: 'Macdona',
  [DfwCities.Madill]: 'Madill',
  [DfwCities.Madisonville]: 'Madisonville',
  [DfwCities.Madrid]: 'Madrid',
  [DfwCities.Magazine]: 'Magazine',
  [DfwCities.MagnetCove]: 'Magnet Cove',
  [DfwCities.Magnolia]: 'Magnolia',
  [DfwCities.Mainz]: 'Mainz',
  [DfwCities.Makati]: 'Makati',
  [DfwCities.Malabon]: 'Malabon',
  [DfwCities.Malaga]: 'Malaga',
  [DfwCities.Malakoff]: 'Malakoff',
  [DfwCities.Malone]: 'Malone',
  [DfwCities.Malvern]: 'Malvern',
  [DfwCities.Managua]: 'Managua',
  [DfwCities.Manchaca]: 'Manchaca',
  [DfwCities.Mandaluyong]: 'Mandaluyong',
  [DfwCities.MandaueCity]: 'Mandaue City',
  [DfwCities.Manila]: 'Manila',
  [DfwCities.Mannsville]: 'Mannsville',
  [DfwCities.Manor]: 'Manor',
  [DfwCities.Manosque]: 'Manosque',
  [DfwCities.Mansfield]: 'Mansfield',
  [DfwCities.Manvel]: 'Manvel',
  [DfwCities.MarbleFalls]: 'Marble Falls',
  [DfwCities.Marcus]: 'Marcus',
  [DfwCities.Marfa]: 'Marfa',
  [DfwCities.Marietta]: 'Marietta',
  [DfwCities.Marikina]: 'Marikina',
  [DfwCities.Marion]: 'Marion',
  [DfwCities.Markham]: 'Markham',
  [DfwCities.Marlin]: 'Marlin',
  [DfwCities.Marlow]: 'Marlow',
  [DfwCities.Marquez]: 'Marquez',
  [DfwCities.Marshall]: 'Marshall',
  [DfwCities.MarshallCreek]: 'Marshall Creek',
  [DfwCities.Mart]: 'Mart',
  [DfwCities.MartinSprings]: 'Martin Springs',
  [DfwCities.Martindale]: 'Martindale',
  [DfwCities.Martinsville]: 'Martinsville',
  [DfwCities.Maryneal]: 'Maryneal',
  [DfwCities.Mason]: 'Mason',
  [DfwCities.Matador]: 'Matador',
  [DfwCities.Matagorda]: 'Matagorda',
  [DfwCities.Mathis]: 'Mathis',
  [DfwCities.Maud]: 'Maud',
  [DfwCities.May]: 'May',
  [DfwCities.Maydelle]: 'Maydelle',
  [DfwCities.Maypearl]: 'Maypearl',
  [DfwCities.Maysfield]: 'Maysfield',
  [DfwCities.McGregor]: 'Mc Gregor',
  [DfwCities.McLeod]: 'Mc Leod',
  [DfwCities.McAlester]: 'McAlester',
  [DfwCities.McAllen]: 'McAllen',
  [DfwCities.McBride]: 'McBride',
  [DfwCities.McCamey]: 'McCamey',
  [DfwCities.McCaulley]: 'McCaulley',
  [DfwCities.McComb]: 'McComb',
  [DfwCities.McKinney]: 'McKinney',
  [DfwCities.McLean]: 'McLean',
  [DfwCities.McLendonChisholm]: 'McLendon Chisholm',
  [DfwCities.McNeil]: 'McNeil',
  [DfwCities.McQueeney]: 'McQueeney',
  [DfwCities.Mead]: 'Mead',
  [DfwCities.Meadow]: 'Meadow',
  [DfwCities.Meadowlakes]: 'Meadowlakes',
  [DfwCities.MeadowsPlace]: 'Meadows Place',
  [DfwCities.Megargel]: 'Megargel',
  [DfwCities.Melissa]: 'Melissa',
  [DfwCities.Melvin]: 'Melvin',
  [DfwCities.Memphis]: 'Memphis',
  [DfwCities.Mena]: 'Mena',
  [DfwCities.Menard]: 'Menard',
  [DfwCities.Mentone]: 'Mentone',
  [DfwCities.Mercedes]: 'Mercedes',
  [DfwCities.Mercury]: 'Mercury',
  [DfwCities.Meridian]: 'Meridian',
  [DfwCities.Merit]: 'Merit',
  [DfwCities.Merkel]: 'Merkel',
  [DfwCities.Mertens]: 'Mertens',
  [DfwCities.Mertzon]: 'Mertzon',
  [DfwCities.Mesquite]: 'Mesquite',
  [DfwCities.Metapan]: 'Metapan',
  [DfwCities.MetcalfGap]: 'Metcalf Gap',
  [DfwCities.Mexia]: 'Mexia',
  [DfwCities.Mexico]: 'Mexico',
  [DfwCities.Miami]: 'Miami',
  [DfwCities.MiamiBeach]: 'Miami Beach',
  [DfwCities.Mico]: 'Mico',
  [DfwCities.Midfield]: 'Midfield',
  [DfwCities.Midland]: 'Midland',
  [DfwCities.Midlothian]: 'Midlothian',
  [DfwCities.Midway]: 'Midway',
  [DfwCities.Milano]: 'Milano',
  [DfwCities.Milburn]: 'Milburn',
  [DfwCities.Mildred]: 'Mildred',
  [DfwCities.Miles]: 'Miles',
  [DfwCities.Milford]: 'Milford',
  [DfwCities.MillCreek]: 'Mill Creek',
  [DfwCities.MillerGrove]: 'Miller Grove',
  [DfwCities.MillersCove]: 'Millers Cove',
  [DfwCities.Millersview]: 'Millersview',
  [DfwCities.Millerton]: 'Millerton',
  [DfwCities.Millican]: 'Millican',
  [DfwCities.Millsap]: 'Millsap',
  [DfwCities.Minden]: 'Minden',
  [DfwCities.Mineola]: 'Mineola',
  [DfwCities.MineralWells]: 'Mineral Wells',
  [DfwCities.Mingus]: 'Mingus',
  [DfwCities.Mission]: 'Mission',
  [DfwCities.Missouri]: 'Missouri',
  [DfwCities.Mobeetie]: 'Mobeetie',
  [DfwCities.Mobile]: 'Mobile',
  [DfwCities.MohoCaye]: 'Moho Caye',
  [DfwCities.Monahans]: 'Monahans',
  [DfwCities.Monkstown]: 'Monkstown',
  [DfwCities.Monrovia]: 'Monrovia',
  [DfwCities.MontBelvieu]: 'Mont Belvieu',
  [DfwCities.Montague]: 'Montague',
  [DfwCities.Montalba]: 'Montalba',
  [DfwCities.MontegoBay]: 'Montego Bay',
  [DfwCities.Monterrey]: 'Monterrey',
  [DfwCities.Montgomery]: 'Montgomery',
  [DfwCities.Montilly]: 'Montilly',
  [DfwCities.Montpellier]: 'Montpellier',
  [DfwCities.Moody]: 'Moody',
  [DfwCities.MooreStation]: 'Moore Station',
  [DfwCities.Mooring]: 'Mooring',
  [DfwCities.Moran]: 'Moran',
  [DfwCities.Morgan]: 'Morgan',
  [DfwCities.MorganMill]: 'Morgan Mill',
  [DfwCities.MorgansPoint]: 'Morgans Point',
  [DfwCities.MorgansPointResort]: 'Morgans Point Resort',
  [DfwCities.MorningStar]: 'Morning Star',
  [DfwCities.Morton]: 'Morton',
  [DfwCities.Mougins]: 'Mougins',
  [DfwCities.Moulton]: 'Moulton',
  [DfwCities.Mound]: 'Mound',
  [DfwCities.MountCalm]: 'Mount Calm',
  [DfwCities.MountEnterprise]: 'Mount Enterprise',
  [DfwCities.MountIda]: 'Mount Ida',
  [DfwCities.MountPleasant]: 'Mount Pleasant',
  [DfwCities.MountSelman]: 'Mount Selman',
  [DfwCities.MountVernon]: 'Mount Vernon',
  [DfwCities.Mountain]: 'Mountain',
  [DfwCities.MountainHome]: 'Mountain Home',
  [DfwCities.MountainValley]: 'Mountain Valley',
  [DfwCities.Mountainburg]: 'Mountainburg',
  [DfwCities.Moyers]: 'Moyers',
  [DfwCities.MtHerman]: 'Mt Herman',
  [DfwCities.MtZion]: 'Mt Zion',
  [DfwCities.Muenster]: 'Muenster',
  [DfwCities.Muldrow]: 'Muldrow',
  [DfwCities.Muleshoe]: 'Muleshoe',
  [DfwCities.Mullin]: 'Mullin',
  [DfwCities.Mumford]: 'Mumford',
  [DfwCities.Munday]: 'Munday',
  [DfwCities.Muntinglupa]: 'Muntinglupa',
  [DfwCities.Murchison]: 'Murchison',
  [DfwCities.Murphy]: 'Murphy',
  [DfwCities.Muse]: 'Muse',
  [DfwCities.Muskogee]: 'Muskogee',
  [DfwCities.Mustang]: 'Mustang',
  [DfwCities.MustangRidge]: 'Mustang Ridge',
  [DfwCities.Myra]: 'Myra',
  [DfwCities.Nacogdoches]: 'Nacogdoches',
  [DfwCities.Nance]: 'Nance',
  [DfwCities.Naples]: 'Naples',
  [DfwCities.Nash]: 'Nash',
  [DfwCities.Nashoba]: 'Nashoba',
  [DfwCities.NassauBay]: 'Nassau Bay',
  [DfwCities.Natalia]: 'Natalia',
  [DfwCities.Navarro]: 'Navarro',
  [DfwCities.Navasota]: 'Navasota',
  [DfwCities.Navotas]: 'Navotas',
  [DfwCities.Nazareth]: 'Nazareth',
  [DfwCities.Neches]: 'Neches',
  [DfwCities.Nederland]: 'Nederland',
  [DfwCities.Needville]: 'Needville',
  [DfwCities.Nelson]: 'Nelson',
  [DfwCities.Nelta]: 'Nelta',
  [DfwCities.Nemo]: 'Nemo',
  [DfwCities.Nesbitt]: 'Nesbitt',
  [DfwCities.Nevada]: 'Nevada',
  [DfwCities.NewBaden]: 'New Baden',
  [DfwCities.NewBerlin]: 'New Berlin',
  [DfwCities.NewBoston]: 'New Boston',
  [DfwCities.NewBraunfels]: 'New Braunfels',
  [DfwCities.NewCaney]: 'New Caney',
  [DfwCities.NewChapelHill]: 'New Chapel Hill',
  [DfwCities.NewFairview]: 'New Fairview',
  [DfwCities.NewHome]: 'New Home',
  [DfwCities.NewHope]: 'New Hope',
  [DfwCities.NewLondon]: 'New London',
  [DfwCities.NewProvidence]: 'New Providence',
  [DfwCities.NewRingold]: 'New Ringold',
  [DfwCities.NewSalem]: 'New Salem',
  [DfwCities.NewSalisbury]: 'New Salisbury',
  [DfwCities.NewSmyrnaBeach]: 'New Smyrna Beach',
  [DfwCities.NewSummerfield]: 'New Summerfield',
  [DfwCities.NewUlm]: 'New Ulm',
  [DfwCities.NewWaverly]: 'New Waverly',
  [DfwCities.NewWoodville]: 'New Woodville',
  [DfwCities.Newark]: 'Newark',
  [DfwCities.Newcastle]: 'Newcastle',
  [DfwCities.Newton]: 'Newton',
  [DfwCities.Neylandville]: 'Neylandville',
  [DfwCities.Nice]: 'Nice',
  [DfwCities.Nida]: 'Nida',
  [DfwCities.Niederwald]: 'Niederwald',
  [DfwCities.Nimes]: 'Nimes',
  [DfwCities.Ninnekah]: 'Ninnekah',
  [DfwCities.Nixon]: 'Nixon',
  [DfwCities.NoCity]: 'No City',
  [DfwCities.Nocona]: 'Nocona',
  [DfwCities.Nolan]: 'Nolan',
  [DfwCities.Nolanville]: 'Nolanville',
  [DfwCities.Nome]: 'Nome',
  [DfwCities.Noodle]: 'Noodle',
  [DfwCities.Noonday]: 'Noonday',
  [DfwCities.Nordheim]: 'Nordheim',
  [DfwCities.Normangee]: 'Normangee',
  [DfwCities.NorthCleveland]: 'North Cleveland',
  [DfwCities.NorthPort]: 'North Port',
  [DfwCities.NorthRichlandHills]: 'North Richland Hills',
  [DfwCities.Northcrest]: 'Northcrest',
  [DfwCities.Northlake]: 'Northlake',
  [DfwCities.Northpole]: 'Northpole',
  [DfwCities.Norwalk]: 'Norwalk',
  [DfwCities.Norway]: 'Norway',
  [DfwCities.Norwood]: 'Norwood',
  [DfwCities.Novice]: 'Novice',
  [DfwCities.NTREISTESTONLY]: 'NTREIS TEST ONLY',
  [DfwCities.Nugent]: 'Nugent',
  [DfwCities.Nunlee]: 'Nunlee',
  [DfwCities.OakGrove]: 'Oak Grove',
  [DfwCities.OakLeaf]: 'Oak Leaf',
  [DfwCities.OakPoint]: 'Oak Point',
  [DfwCities.OakRidge]: 'Oak Ridge',
  [DfwCities.OakRidgeNorth]: 'Oak Ridge North',
  [DfwCities.OakValley]: 'Oak Valley',
  [DfwCities.Oakhurst]: 'Oakhurst',
  [DfwCities.Oakland]: 'Oakland',
  [DfwCities.Oakman]: 'Oakman',
  [DfwCities.Oakville]: 'Oakville',
  [DfwCities.Oakwood]: 'Oakwood',
  [DfwCities.OBrien]: 'OBrien',
  [DfwCities.OceanCity]: 'Ocean City',
  [DfwCities.Odell]: 'Odell',
  [DfwCities.Odem]: 'Odem',
  [DfwCities.Odessa]: 'Odessa',
  [DfwCities.ODonnell]: 'ODonnell',
  [DfwCities.Oglesby]: 'Oglesby',
  [DfwCities.OhioCity]: 'Ohio City',
  [DfwCities.OilCenter]: 'Oil Center',
  [DfwCities.Ojochal]: 'Ojochal',
  [DfwCities.OklahomaCity]: 'Oklahoma City',
  [DfwCities.Oklaunion]: 'Oklaunion',
  [DfwCities.OldGlory]: 'Old Glory',
  [DfwCities.OldRiverWinfree]: 'Old River Winfree',
  [DfwCities.Olden]: 'Olden',
  [DfwCities.OlmosPark]: 'Olmos Park',
  [DfwCities.Olney]: 'Olney',
  [DfwCities.Olton]: 'Olton',
  [DfwCities.Omaha]: 'Omaha',
  [DfwCities.Onalaska]: 'Onalaska',
  [DfwCities.OpdykeWest]: 'Opdyke West',
  [DfwCities.Oplin]: 'Oplin',
  [DfwCities.Orange]: 'Orange',
  [DfwCities.OrangeGrove]: 'Orange Grove',
  [DfwCities.Oranjestad]: 'Oranjestad',
  [DfwCities.Orchard]: 'Orchard',
  [DfwCities.Ordgrant]: 'Ordgrant',
  [DfwCities.OreCity]: 'Ore City',
  [DfwCities.Otto]: 'Otto',
  [DfwCities.Ovalo]: 'Ovalo',
  [DfwCities.Overbrook]: 'Overbrook',
  [DfwCities.Overton]: 'Overton',
  [DfwCities.Ovilla]: 'Ovilla',
  [DfwCities.Owens]: 'Owens',
  [DfwCities.Owensville]: 'Owensville',
  [DfwCities.Owenton]: 'Owenton',
  [DfwCities.Oxford]: 'Oxford',
  [DfwCities.OysterCreek]: 'Oyster Creek',
  [DfwCities.Ozona]: 'Ozona',
  [DfwCities.Pezenas]: 'Pezenas',
  [DfwCities.Paducah]: 'Paducah',
  [DfwCities.PagosaSprings]: 'Pagosa Springs',
  [DfwCities.PaintRock]: 'Paint Rock',
  [DfwCities.Palacios]: 'Palacios',
  [DfwCities.Palestine]: 'Palestine',
  [DfwCities.Palisades]: 'Palisades',
  [DfwCities.PalmValley]: 'Palm Valley',
  [DfwCities.Palmer]: 'Palmer',
  [DfwCities.Palmetto]: 'Palmetto',
  [DfwCities.Palmhurst]: 'Palmhurst',
  [DfwCities.Palmview]: 'Palmview',
  [DfwCities.PaloPinto]: 'Palo Pinto',
  [DfwCities.Paluxy]: 'Paluxy',
  [DfwCities.Pampa]: 'Pampa',
  [DfwCities.PanamaCity]: 'Panama City',
  [DfwCities.PanamaCityBeach]: 'Panama City Beach',
  [DfwCities.Panhandle]: 'Panhandle',
  [DfwCities.PannaMaria]: 'Panna Maria',
  [DfwCities.Panola]: 'Panola',
  [DfwCities.PanoramaVillage]: 'Panorama Village',
  [DfwCities.Pantego]: 'Pantego',
  [DfwCities.Paradise]: 'Paradise',
  [DfwCities.Paranaque]: 'Paranaque',
  [DfwCities.Paris]: 'Paris',
  [DfwCities.Parker]: 'Parker',
  [DfwCities.Paron]: 'Paron',
  [DfwCities.Parrish]: 'Parrish',
  [DfwCities.Pasadena]: 'Pasadena',
  [DfwCities.Pasay]: 'Pasay',
  [DfwCities.Pasig]: 'Pasig',
  [DfwCities.Pateros]: 'Pateros',
  [DfwCities.Pattison]: 'Pattison',
  [DfwCities.PattonVillage]: 'Patton Village',
  [DfwCities.Pattonville]: 'Pattonville',
  [DfwCities.PayneSprings]: 'Payne Springs',
  [DfwCities.Peacock]: 'Peacock',
  [DfwCities.Peadenville]: 'Peadenville',
  [DfwCities.Pearcy]: 'Pearcy',
  [DfwCities.Pearland]: 'Pearland',
  [DfwCities.Pearsall]: 'Pearsall',
  [DfwCities.Peaster]: 'Peaster',
  [DfwCities.PecanGap]: 'Pecan Gap',
  [DfwCities.PecanHill]: 'Pecan Hill',
  [DfwCities.Pecos]: 'Pecos',
  [DfwCities.PelicanBay]: 'Pelican Bay',
  [DfwCities.Pendleton]: 'Pendleton',
  [DfwCities.Penelope]: 'Penelope',
  [DfwCities.PeninsulaPapagayo]: 'Peninsula Papagayo',
  [DfwCities.Penitas]: 'Penitas',
  [DfwCities.PennValley]: 'Penn Valley',
  [DfwCities.Peoria]: 'Peoria',
  [DfwCities.Perla]: 'Perla',
  [DfwCities.PernitasPoint]: 'Pernitas Point',
  [DfwCities.Perrin]: 'Perrin',
  [DfwCities.Perry]: 'Perry',
  [DfwCities.Perryton]: 'Perryton',
  [DfwCities.Pertuis]: 'Pertuis',
  [DfwCities.Peru]: 'Peru',
  [DfwCities.Petersburg]: 'Petersburg',
  [DfwCities.Petrolia]: 'Petrolia',
  [DfwCities.Petronila]: 'Petronila',
  [DfwCities.Petty]: 'Petty',
  [DfwCities.Pettyview]: 'Pettyview',
  [DfwCities.Pflugerville]: 'Pflugerville',
  [DfwCities.Pharr]: 'Pharr',
  [DfwCities.Phoenix]: 'Phoenix',
  [DfwCities.Pickens]: 'Pickens',
  [DfwCities.Pickett]: 'Pickett',
  [DfwCities.Pickton]: 'Pickton',
  [DfwCities.Pickwick]: 'Pickwick',
  [DfwCities.PiedrasNegras]: 'Piedras Negras',
  [DfwCities.Pike]: 'Pike',
  [DfwCities.Pikeville]: 'Pikeville',
  [DfwCities.PilotGrove]: 'Pilot Grove',
  [DfwCities.PilotPoint]: 'Pilot Point',
  [DfwCities.PineForest]: 'Pine Forest',
  [DfwCities.PineIsland]: 'Pine Island',
  [DfwCities.Pinehurst]: 'Pinehurst',
  [DfwCities.Pineland]: 'Pineland',
  [DfwCities.PineyPointVillage]: 'Piney Point Village',
  [DfwCities.Pioneer]: 'Pioneer',
  [DfwCities.Pittsburg]: 'Pittsburg',
  [DfwCities.Placid]: 'Placid',
  [DfwCities.Plains]: 'Plains',
  [DfwCities.Plainview]: 'Plainview',
  [DfwCities.Plano]: 'Plano',
  [DfwCities.Platter]: 'Platter',
  [DfwCities.PlayaBandera]: 'Playa Bandera',
  [DfwCities.PlayaBlanca]: 'Playa Blanca',
  [DfwCities.PlayadelCarmen]: 'Playa del Carmen',
  [DfwCities.PlayadelCoco]: 'Playa del Coco',
  [DfwCities.PlayaHermosa]: 'Playa Hermosa',
  [DfwCities.Pleak]: 'Pleak',
  [DfwCities.PleasantHill]: 'Pleasant Hill',
  [DfwCities.PleasantValley]: 'Pleasant Valley',
  [DfwCities.Pleasanton]: 'Pleasanton',
  [DfwCities.Pledger]: 'Pledger',
  [DfwCities.PlumGrove]: 'Plum Grove',
  [DfwCities.Poetry]: 'Poetry',
  [DfwCities.Point]: 'Point',
  [DfwCities.PointBlank]: 'Point Blank',
  [DfwCities.PointComfort]: 'Point Comfort',
  [DfwCities.PointDecar]: 'Point Decar',
  [DfwCities.Ponder]: 'Ponder',
  [DfwCities.Pontotoc]: 'Pontotoc',
  [DfwCities.PontSaintEsprit]: 'Pont-Saint-Esprit',
  [DfwCities.Poolville]: 'Poolville',
  [DfwCities.PortAransas]: 'Port Aransas',
  [DfwCities.PortArthur]: 'Port Arthur',
  [DfwCities.PortBolivar]: 'Port Bolivar',
  [DfwCities.PortIsabel]: 'Port Isabel',
  [DfwCities.PortLavaca]: 'Port Lavaca',
  [DfwCities.PortNeches]: 'Port Neches',
  [DfwCities.PortOrange]: 'Port Orange',
  [DfwCities.Portland]: 'Portland',
  [DfwCities.PossumKingdomLake]: 'Possum Kingdom Lake',
  [DfwCities.Post]: 'Post',
  [DfwCities.PostOakBend]: 'Post Oak Bend',
  [DfwCities.Poteau]: 'Poteau',
  [DfwCities.Poteet]: 'Poteet',
  [DfwCities.Poth]: 'Poth',
  [DfwCities.Potosi]: 'Potosi',
  [DfwCities.Pottsboro]: 'Pottsboro',
  [DfwCities.Pottsville]: 'Pottsville',
  [DfwCities.Powderly]: 'Powderly',
  [DfwCities.Powell]: 'Powell',
  [DfwCities.Poynor]: 'Poynor',
  [DfwCities.PrairieHill]: 'Prairie Hill',
  [DfwCities.PrairieLea]: 'Prairie Lea',
  [DfwCities.PrairieView]: 'Prairie View',
  [DfwCities.Praslin]: 'Praslin',
  [DfwCities.Pray]: 'Pray',
  [DfwCities.Premont]: 'Premont',
  [DfwCities.Presidio]: 'Presidio',
  [DfwCities.Preston]: 'Preston',
  [DfwCities.Prestonsburg]: 'Prestonsburg',
  [DfwCities.Price]: 'Price',
  [DfwCities.Priddy]: 'Priddy',
  [DfwCities.Primera]: 'Primera',
  [DfwCities.Princeton]: 'Princeton',
  [DfwCities.Proctor]: 'Proctor',
  [DfwCities.Progreso]: 'Progreso',
  [DfwCities.ProgresoLakes]: 'Progreso Lakes',
  [DfwCities.Prosper]: 'Prosper',
  [DfwCities.ProvidenceVillage]: 'Providence Village',
  [DfwCities.Provincetown]: 'Provincetown',
  [DfwCities.Pucon]: 'Pucon',
  [DfwCities.PuntaMita]: 'Punta Mita',
  [DfwCities.Purcell]: 'Purcell',
  [DfwCities.Purdon]: 'Purdon',
  [DfwCities.Purmela]: 'Purmela',
  [DfwCities.Purves]: 'Purves',
  [DfwCities.Putnam]: 'Putnam',
  [DfwCities.Pyote]: 'Pyote',
  [DfwCities.Quanah]: 'Quanah',
  [DfwCities.QueenCity]: 'Queen City',
  [DfwCities.Quemado]: 'Quemado',
  [DfwCities.QuezonCity]: 'Quezon City',
  [DfwCities.Quimper]: 'Quimper',
  [DfwCities.Quinlan]: 'Quinlan',
  [DfwCities.Quintana]: 'Quintana',
  [DfwCities.Quitaque]: 'Quitaque',
  [DfwCities.Quitman]: 'Quitman',
  [DfwCities.Rainbow]: 'Rainbow',
  [DfwCities.Ralls]: 'Ralls',
  [DfwCities.RanchoViejo]: 'Rancho Viejo',
  [DfwCities.Randlett]: 'Randlett',
  [DfwCities.Randolph]: 'Randolph',
  [DfwCities.Ranger]: 'Ranger',
  [DfwCities.Rangerville]: 'Rangerville',
  [DfwCities.Rankin]: 'Rankin',
  [DfwCities.Ratcliff]: 'Ratcliff',
  [DfwCities.Ravenna]: 'Ravenna',
  [DfwCities.Ravia]: 'Ravia',
  [DfwCities.Raymondville]: 'Raymondville',
  [DfwCities.Reagan]: 'Reagan',
  [DfwCities.RedLick]: 'Red Lick',
  [DfwCities.RedOak]: 'Red Oak',
  [DfwCities.RedRiver]: 'Red River',
  [DfwCities.Redwater]: 'Redwater',
  [DfwCities.Reese]: 'Reese',
  [DfwCities.Refugio]: 'Refugio',
  [DfwCities.Regency]: 'Regency',
  [DfwCities.Reklaw]: 'Reklaw',
  [DfwCities.Remsenburg]: 'Remsenburg',
  [DfwCities.Rendon]: 'Rendon',
  [DfwCities.Reno]: 'Reno',
  [DfwCities.Retreat]: 'Retreat',
  [DfwCities.Reydon]: 'Reydon',
  [DfwCities.RheaMills]: 'Rhea Mills',
  [DfwCities.Rhome]: 'Rhome',
  [DfwCities.Rice]: 'Rice',
  [DfwCities.Richardson]: 'Richardson',
  [DfwCities.Richland]: 'Richland',
  [DfwCities.RichlandHills]: 'Richland Hills',
  [DfwCities.RichlandSprings]: 'Richland Springs',
  [DfwCities.Richmond]: 'Richmond',
  [DfwCities.Richwood]: 'Richwood',
  [DfwCities.Ridge]: 'Ridge',
  [DfwCities.Ridgeway]: 'Ridgeway',
  [DfwCities.Riesel]: 'Riesel',
  [DfwCities.Ringgold]: 'Ringgold',
  [DfwCities.Ringling]: 'Ringling',
  [DfwCities.Ringold]: 'Ringold',
  [DfwCities.RioBravo]: 'Rio Bravo',
  [DfwCities.RioDeJaneiro]: 'Rio De Janeiro',
  [DfwCities.RioGrandeCity]: 'Rio Grande City',
  [DfwCities.RioHato]: 'Rio Hato',
  [DfwCities.RioHondo]: 'Rio Hondo',
  [DfwCities.RioMedina]: 'Rio Medina',
  [DfwCities.RioVista]: 'Rio Vista',
  [DfwCities.RisingStar]: 'Rising Star',
  [DfwCities.RiverOaks]: 'River Oaks',
  [DfwCities.Riverby]: 'Riverby',
  [DfwCities.Riverside]: 'Riverside',
  [DfwCities.Roane]: 'Roane',
  [DfwCities.Roanoke]: 'Roanoke',
  [DfwCities.RoaringSprings]: 'Roaring Springs',
  [DfwCities.Roatan]: 'Roatan',
  [DfwCities.RobertLee]: 'Robert Lee',
  [DfwCities.Roberta]: 'Roberta',
  [DfwCities.Robinson]: 'Robinson',
  [DfwCities.Robs]: 'Robs',
  [DfwCities.Robstown]: 'Robstown',
  [DfwCities.Roby]: 'Roby',
  [DfwCities.Rochelle]: 'Rochelle',
  [DfwCities.Rochester]: 'Rochester',
  [DfwCities.RockSprings]: 'Rock Springs',
  [DfwCities.Rockdale]: 'Rockdale',
  [DfwCities.Rockett]: 'Rockett',
  [DfwCities.Rockport]: 'Rockport',
  [DfwCities.Rockport2]: 'Rockport',
  [DfwCities.Rocksprings]: 'Rocksprings',
  [DfwCities.Rockwall]: 'Rockwall',
  [DfwCities.Rockwood]: 'Rockwood',
  [DfwCities.Rocky]: 'Rocky',
  [DfwCities.RockyMound]: 'Rocky Mound',
  [DfwCities.Roff]: 'Roff',
  [DfwCities.Rogers]: 'Rogers',
  [DfwCities.Rolia]: 'Rolia',
  [DfwCities.Roll]: 'Roll',
  [DfwCities.Rollingwood]: 'Rollingwood',
  [DfwCities.RomanForest]: 'Roman Forest',
  [DfwCities.Romans]: 'Romans',
  [DfwCities.Rome]: 'Rome',
  [DfwCities.Ropesville]: 'Ropesville',
  [DfwCities.Rosanky]: 'Rosanky',
  [DfwCities.Roscoe]: 'Roscoe',
  [DfwCities.Rose]: 'Rose',
  [DfwCities.RoseHillAcres]: 'Rose Hill Acres',
  [DfwCities.Rosebud]: 'Rosebud',
  [DfwCities.Rosenberg]: 'Rosenberg',
  [DfwCities.Ross]: 'Ross',
  [DfwCities.Rosser]: 'Rosser',
  [DfwCities.Rosston]: 'Rosston',
  [DfwCities.Rotan]: 'Rotan',
  [DfwCities.RoundMountain]: 'Round Mountain',
  [DfwCities.RoundRock]: 'Round Rock',
  [DfwCities.RoundTop]: 'Round Top',
  [DfwCities.Rowden]: 'Rowden',
  [DfwCities.Rowlett]: 'Rowlett',
  [DfwCities.Roxton]: 'Roxton',
  [DfwCities.Royal]: 'Royal',
  [DfwCities.RoyseCity]: 'Royse City',
  [DfwCities.Rubottom]: 'Rubottom',
  [DfwCities.Rule]: 'Rule',
  [DfwCities.RunawayBay]: 'Runaway Bay',
  [DfwCities.Runge]: 'Runge',
  [DfwCities.Rusk]: 'Rusk',
  [DfwCities.Russett]: 'Russett',
  [DfwCities.RyanPark]: 'Ryan Park',
  [DfwCities.Sabinal]: 'Sabinal',
  [DfwCities.Sachse]: 'Sachse',
  [DfwCities.Sacul]: 'Sacul',
  [DfwCities.Sadler]: 'Sadler',
  [DfwCities.Saginaw]: 'Saginaw',
  [DfwCities.SaintClairsville]: 'Saint Clairsville',
  [DfwCities.SaintHedwig]: 'Saint Hedwig',
  [DfwCities.SaintJo]: 'Saint Jo',
  [DfwCities.SaintJoseph]: 'Saint Joseph',
  [DfwCities.SaintPaul]: 'Saint Paul',
  [DfwCities.Salado]: 'Salado',
  [DfwCities.Salem]: 'Salem',
  [DfwCities.Salesville]: 'Salesville',
  [DfwCities.Salida]: 'Salida',
  [DfwCities.SalondeProvence]: 'Salon-de-Provence',
  [DfwCities.SaltGap]: 'Salt Gap',
  [DfwCities.Saltillo]: 'Saltillo',
  [DfwCities.SanAngelo]: 'San Angelo',
  [DfwCities.SanAntonio]: 'San Antonio',
  [DfwCities.SanAugustine]: 'San Augustine',
  [DfwCities.SanBenito]: 'San Benito',
  [DfwCities.SanDiego]: 'San Diego',
  [DfwCities.SanElizario]: 'San Elizario',
  [DfwCities.SanFelipe]: 'San Felipe',
  [DfwCities.SanIsidro]: 'San Isidro',
  [DfwCities.SanJose]: 'San Jose',
  [DfwCities.SanJuan]: 'San Juan',
  [DfwCities.SanJuandelMonte]: 'San Juan del Monte',
  [DfwCities.SanLeanna]: 'San Leanna',
  [DfwCities.SanMarcos]: 'San Marcos',
  [DfwCities.SanMiguel]: 'San Miguel',
  [DfwCities.SanPatricio]: 'San Patricio',
  [DfwCities.SanPedro]: 'San Pedro',
  [DfwCities.SanPerlita]: 'San Perlita',
  [DfwCities.SanSaba]: 'San Saba',
  [DfwCities.SanSalvador]: 'San Salvador',
  [DfwCities.SanSebastian]: 'San Sebastian',
  [DfwCities.Sanctuary]: 'Sanctuary',
  [DfwCities.Sandbluff]: 'Sandbluff',
  [DfwCities.Sanderson]: 'Sanderson',
  [DfwCities.Sanger]: 'Sanger',
  [DfwCities.SansomPark]: 'Sansom Park',
  [DfwCities.SantaAna]: 'Santa Ana',
  [DfwCities.SantaAnna]: 'Santa Anna',
  [DfwCities.SantaFe]: 'Santa Fe',
  [DfwCities.SantaMarta]: 'Santa Marta',
  [DfwCities.SantaRosa]: 'Santa Rosa',
  [DfwCities.Santo]: 'Santo',
  [DfwCities.SantoDomingo]: 'Santo Domingo',
  [DfwCities.Sarasota]: 'Sarasota',
  [DfwCities.Sardis]: 'Sardis',
  [DfwCities.Satin]: 'Satin',
  [DfwCities.Savannah]: 'Savannah',
  [DfwCities.Savoy]: 'Savoy',
  [DfwCities.Sawyer]: 'Sawyer',
  [DfwCities.Sayre]: 'Sayre',
  [DfwCities.Schertz]: 'Schertz',
  [DfwCities.Schulenburg]: 'Schulenburg',
  [DfwCities.Schwertner]: 'Schwertner',
  [DfwCities.Scotland]: 'Scotland',
  [DfwCities.Scottsville]: 'Scottsville',
  [DfwCities.Scroggins]: 'Scroggins',
  [DfwCities.Scurry]: 'Scurry',
  [DfwCities.Seabrook]: 'Seabrook',
  [DfwCities.Seadrift]: 'Seadrift',
  [DfwCities.Seagoville]: 'Seagoville',
  [DfwCities.Seagraves]: 'Seagraves',
  [DfwCities.Sealy]: 'Sealy',
  [DfwCities.Sedalia]: 'Sedalia',
  [DfwCities.Sedona]: 'Sedona',
  [DfwCities.Seguin]: 'Seguin',
  [DfwCities.Selden]: 'Selden',
  [DfwCities.Selma]: 'Selma',
  [DfwCities.SelmanCity]: 'Selman City',
  [DfwCities.Seminole]: 'Seminole',
  [DfwCities.Sens]: 'Sens',
  [DfwCities.Sentinel]: 'Sentinel',
  [DfwCities.SevenOaks]: 'Seven Oaks',
  [DfwCities.SevenPoints]: 'Seven Points',
  [DfwCities.Sevilla]: 'Sevilla',
  [DfwCities.Seymore]: 'Seymore',
  [DfwCities.Seymour]: 'Seymour',
  [DfwCities.ShadyShores]: 'Shady Shores',
  [DfwCities.Shamrock]: 'Shamrock',
  [DfwCities.ShavanoPark]: 'Shavano Park',
  [DfwCities.Shenandoah]: 'Shenandoah',
  [DfwCities.Shepherd]: 'Shepherd',
  [DfwCities.Sherman]: 'Sherman',
  [DfwCities.Shiner]: 'Shiner',
  [DfwCities.Shirley]: 'Shirley',
  [DfwCities.Shive]: 'Shive',
  [DfwCities.Shoreacres]: 'Shoreacres',
  [DfwCities.Sidney]: 'Sidney',
  [DfwCities.SierraBlanca]: 'Sierra Blanca',
  [DfwCities.Silo]: 'Silo',
  [DfwCities.Silsbee]: 'Silsbee',
  [DfwCities.Silverton]: 'Silverton',
  [DfwCities.Simms]: 'Simms',
  [DfwCities.Simonton]: 'Simonton',
  [DfwCities.Sinton]: 'Sinton',
  [DfwCities.SiouxFalls]: 'Sioux Falls',
  [DfwCities.Skelly]: 'Skelly',
  [DfwCities.Slaton]: 'Slaton',
  [DfwCities.Slidell]: 'Slidell',
  [DfwCities.Smiley]: 'Smiley',
  [DfwCities.Smithland]: 'Smithland',
  [DfwCities.Smithville]: 'Smithville',
  [DfwCities.Smyer]: 'Smyer',
  [DfwCities.Snook]: 'Snook',
  [DfwCities.Snoqualmie]: 'Snoqualmie',
  [DfwCities.Snyder]: 'Snyder',
  [DfwCities.SocialHill]: 'Social Hill',
  [DfwCities.Socorro]: 'Socorro',
  [DfwCities.Somerset]: 'Somerset',
  [DfwCities.Somerville]: 'Somerville',
  [DfwCities.Sonora]: 'Sonora',
  [DfwCities.Sonsonate]: 'Sonsonate',
  [DfwCities.Soper]: 'Soper',
  [DfwCities.Sosua]: 'Sosua',
  [DfwCities.SourLake]: 'Sour Lake',
  [DfwCities.SouthBend]: 'South Bend',
  [DfwCities.SouthHouston]: 'South Houston',
  [DfwCities.SouthLakeTahoe]: 'South Lake Tahoe',
  [DfwCities.SouthMountain]: 'South Mountain',
  [DfwCities.SouthPadreIsland]: 'South Padre Island',
  [DfwCities.Southerland]: 'Southerland',
  [DfwCities.Southlake]: 'Southlake',
  [DfwCities.Southmayd]: 'Southmayd',
  [DfwCities.SouthsidePlace]: 'Southside Place',
  [DfwCities.Spearman]: 'Spearman',
  [DfwCities.Spicewood]: 'Spicewood',
  [DfwCities.Splendora]: 'Splendora',
  [DfwCities.Spofford]: 'Spofford',
  [DfwCities.Spring]: 'Spring',
  [DfwCities.SpringBranch]: 'Spring Branch',
  [DfwCities.SpringValley]: 'Spring Valley',
  [DfwCities.Springdale]: 'Springdale',
  [DfwCities.Springlake]: 'Springlake',
  [DfwCities.Springtown]: 'Springtown',
  [DfwCities.Spur]: 'Spur',
  [DfwCities.StPaul]: 'St Paul',
  [DfwCities.StAndrews]: 'St. Andrews',
  [DfwCities.StEmilion]: 'St. Emilion',
  [DfwCities.StHedwig]: 'St. Hedwig',
  [DfwCities.StRaphael]: 'St. Raphael',
  [DfwCities.StSimonsIsland]: 'St. Simons Island',
  [DfwCities.StTropez]: 'St. Tropez',
  [DfwCities.Stafford]: 'Stafford',
  [DfwCities.Stagecoach]: 'Stagecoach',
  [DfwCities.Stamford]: 'Stamford',
  [DfwCities.Stanton]: 'Stanton',
  [DfwCities.Staples]: 'Staples',
  [DfwCities.Star]: 'Star',
  [DfwCities.StarHarbor]: 'Star Harbor',
  [DfwCities.Stephenville]: 'Stephenville',
  [DfwCities.Sterling]: 'Sterling',
  [DfwCities.SterlingCity]: 'Sterling City',
  [DfwCities.Stillwater]: 'Stillwater',
  [DfwCities.Stinnett]: 'Stinnett',
  [DfwCities.Stockdale]: 'Stockdale',
  [DfwCities.StomsriverVillage]: 'Stomsriver Village',
  [DfwCities.Stonewall]: 'Stonewall',
  [DfwCities.Stratford]: 'Stratford',
  [DfwCities.Strawn]: 'Strawn',
  [DfwCities.Streetman]: 'Streetman',
  [DfwCities.StrongCity]: 'Strong City',
  [DfwCities.Sudan]: 'Sudan',
  [DfwCities.SugarLand]: 'Sugar Land',
  [DfwCities.Sulphur]: 'Sulphur',
  [DfwCities.SulphurBluff]: 'Sulphur Bluff',
  [DfwCities.SulphurSprings]: 'Sulphur Springs',
  [DfwCities.Sumner]: 'Sumner',
  [DfwCities.SunCityWest]: 'Sun City West',
  [DfwCities.SunValley]: 'Sun Valley',
  [DfwCities.Sundown]: 'Sundown',
  [DfwCities.Sunnyvale]: 'Sunnyvale',
  [DfwCities.Sunray]: 'Sunray',
  [DfwCities.SunriseBeachVillage]: 'Sunrise Beach Village',
  [DfwCities.Sunset]: 'Sunset',
  [DfwCities.SunsetValley]: 'Sunset Valley',
  [DfwCities.SurfsideBeach]: 'Surfside Beach',
  [DfwCities.SutherlandSprings]: 'Sutherland Springs',
  [DfwCities.Sweeny]: 'Sweeny',
  [DfwCities.Sweetwater]: 'Sweetwater',
  [DfwCities.Swink]: 'Swink',
  [DfwCities.Sylvester]: 'Sylvester',
  [DfwCities.Taft]: 'Taft',
  [DfwCities.Taguig]: 'Taguig',
  [DfwCities.Tahoka]: 'Tahoka',
  [DfwCities.Talco]: 'Talco',
  [DfwCities.Talihina]: 'Talihina',
  [DfwCities.Talpa]: 'Talpa',
  [DfwCities.Talty]: 'Talty',
  [DfwCities.Tappahannock]: 'Tappahannock',
  [DfwCities.Tarcoles]: 'Tarcoles',
  [DfwCities.Tatum]: 'Tatum',
  [DfwCities.Taylor]: 'Taylor',
  [DfwCities.TaylorLakeVillage]: 'Taylor Lake Village',
  [DfwCities.Teague]: 'Teague',
  [DfwCities.Tehuacana]: 'Tehuacana',
  [DfwCities.Telephone]: 'Telephone',
  [DfwCities.Telico]: 'Telico',
  [DfwCities.Telluride]: 'Telluride',
  [DfwCities.Temple]: 'Temple',
  [DfwCities.Tenaha]: 'Tenaha',
  [DfwCities.TennesseeColony]: 'Tennessee Colony',
  [DfwCities.TerraCeia]: 'Terra Ceia',
  [DfwCities.Terral]: 'Terral',
  [DfwCities.Terrell]: 'Terrell',
  [DfwCities.TerrellHills]: 'Terrell Hills',
  [DfwCities.Texarkana]: 'Texarkana',
  [DfwCities.Texas]: 'Texas',
  [DfwCities.Texhoma]: 'Texhoma',
  [DfwCities.Texline]: 'Texline',
  [DfwCities.Thackerville]: 'Thackerville',
  [DfwCities.TheColony]: 'The Colony',
  [DfwCities.TheCrane]: 'The Crane',
  [DfwCities.TheHills]: 'The Hills',
  [DfwCities.TheWoodlands]: 'The Woodlands',
  [DfwCities.Thompsons]: 'Thompsons',
  [DfwCities.Thorndale]: 'Thorndale',
  [DfwCities.Thornton]: 'Thornton',
  [DfwCities.Thorntonville]: 'Thorntonville',
  [DfwCities.Thrall]: 'Thrall',
  [DfwCities.ThreeRivers]: 'Three Rivers',
  [DfwCities.Thrifty]: 'Thrifty',
  [DfwCities.Throckmorton]: 'Throckmorton',
  [DfwCities.Tigard]: 'Tigard',
  [DfwCities.TikiIsland]: 'Tiki Island',
  [DfwCities.Tilden]: 'Tilden',
  [DfwCities.TimbercreekCanyon]: 'Timbercreek Canyon',
  [DfwCities.Timpson]: 'Timpson',
  [DfwCities.Tioga]: 'Tioga',
  [DfwCities.Tira]: 'Tira',
  [DfwCities.Tishomingo]: 'Tishomingo',
  [DfwCities.Tivoli]: 'Tivoli',
  [DfwCities.Toco]: 'Toco',
  [DfwCities.ToddMission]: 'Todd Mission',
  [DfwCities.Tolar]: 'Tolar',
  [DfwCities.Tom]: 'Tom',
  [DfwCities.TomBean]: 'Tom Bean',
  [DfwCities.Tomball]: 'Tomball',
  [DfwCities.Tool]: 'Tool',
  [DfwCities.Tornillo]: 'Tornillo',
  [DfwCities.Toulouse]: 'Toulouse',
  [DfwCities.Tow]: 'Tow',
  [DfwCities.Toyah]: 'Toyah',
  [DfwCities.Traskwood]: 'Traskwood',
  [DfwCities.Trent]: 'Trent',
  [DfwCities.Trenton]: 'Trenton',
  [DfwCities.Trickham]: 'Trickham',
  [DfwCities.Trinidad]: 'Trinidad',
  [DfwCities.Trinity]: 'Trinity',
  [DfwCities.TrophyClub]: 'Trophy Club',
  [DfwCities.Troup]: 'Troup',
  [DfwCities.Troy]: 'Troy',
  [DfwCities.Trumbull]: 'Trumbull',
  [DfwCities.Tulia]: 'Tulia',
  [DfwCities.Tupelo]: 'Tupelo',
  [DfwCities.Turkey]: 'Turkey',
  [DfwCities.TurksCaicosIslands]: 'Turks & Caicos Islands',
  [DfwCities.Turney]: 'Turney',
  [DfwCities.Tuscany]: 'Tuscany',
  [DfwCities.Tuscola]: 'Tuscola',
  [DfwCities.Tuskahoma]: 'Tuskahoma',
  [DfwCities.Tye]: 'Tye',
  [DfwCities.Tyler]: 'Tyler',
  [DfwCities.Uhland]: 'Uhland',
  [DfwCities.Uncertain]: 'Uncertain',
  [DfwCities.Unger]: 'Unger',
  [DfwCities.UnionGrove]: 'Union Grove',
  [DfwCities.UnionHill]: 'Union Hill',
  [DfwCities.UnionValley]: 'Union Valley',
  [DfwCities.UniversalCity]: 'Universal City',
  [DfwCities.UniversityPark]: 'University Park',
  [DfwCities.Usulutan]: 'Usulutan',
  [DfwCities.Utica]: 'Utica',
  [DfwCities.Utila]: 'Utila',
  [DfwCities.Uvalde]: 'Uvalde',
  [DfwCities.Uvita]: 'Uvita',
  [DfwCities.Uzes]: 'Uzes',
  [DfwCities.Valencia]: 'Valencia',
  [DfwCities.Valentine]: 'Valentine',
  [DfwCities.Valenzuela]: 'Valenzuela',
  [DfwCities.Valera]: 'Valera',
  [DfwCities.Valiant]: 'Valiant',
  [DfwCities.ValleyMills]: 'Valley Mills',
  [DfwCities.ValleySpring]: 'Valley Spring',
  [DfwCities.ValleyView]: 'Valley View',
  [DfwCities.Valliant]: 'Valliant',
  [DfwCities.Van]: 'Van',
  [DfwCities.VanAlstyne]: 'Van Alstyne',
  [DfwCities.VanBuren]: 'Van Buren',
  [DfwCities.VanHorn]: 'Van Horn',
  [DfwCities.VanVleck]: 'Van Vleck',
  [DfwCities.Varna]: 'Varna',
  [DfwCities.Vaucluse]: 'Vaucluse',
  [DfwCities.Vega]: 'Vega',
  [DfwCities.Venus]: 'Venus',
  [DfwCities.Vernon]: 'Vernon',
  [DfwCities.Vichy]: 'Vichy',
  [DfwCities.Victoria]: 'Victoria',
  [DfwCities.Vidor]: 'Vidor',
  [DfwCities.Vigo]: 'Vigo',
  [DfwCities.Vilas]: 'Vilas',
  [DfwCities.Villefranche]: 'Villefranche',
  [DfwCities.Vimy]: 'Vimy',
  [DfwCities.Vinita]: 'Vinita',
  [DfwCities.Vinton]: 'Vinton',
  [DfwCities.Voca]: 'Voca',
  [DfwCities.VonOrmy]: 'Von Ormy',
  [DfwCities.Voss]: 'Voss',
  [DfwCities.Waco]: 'Waco',
  [DfwCities.Wade]: 'Wade',
  [DfwCities.Wadsworth]: 'Wadsworth',
  [DfwCities.Waelder]: 'Waelder',
  [DfwCities.Wagner]: 'Wagner',
  [DfwCities.Wake]: 'Wake',
  [DfwCities.WakeVillage]: 'Wake Village',
  [DfwCities.Walburg]: 'Walburg',
  [DfwCities.Waldron]: 'Waldron',
  [DfwCities.Waller]: 'Waller',
  [DfwCities.Wallis]: 'Wallis',
  [DfwCities.WalnutSprings]: 'Walnut Springs',
  [DfwCities.Walters]: 'Walters',
  [DfwCities.Wamego]: 'Wamego',
  [DfwCities.Warren]: 'Warren',
  [DfwCities.Washington]: 'Washington',
  [DfwCities.Waskom]: 'Waskom',
  [DfwCities.Watauga]: 'Watauga',
  [DfwCities.Watson]: 'Watson',
  [DfwCities.Waxahachie]: 'Waxahachie',
  [DfwCities.Weatherford]: 'Weatherford',
  [DfwCities.Weaver]: 'Weaver',
  [DfwCities.Webster]: 'Webster',
  [DfwCities.Weimar]: 'Weimar',
  [DfwCities.Weinert]: 'Weinert',
  [DfwCities.Weir]: 'Weir',
  [DfwCities.Wellborn]: 'Wellborn',
  [DfwCities.Wellington]: 'Wellington',
  [DfwCities.Wellman]: 'Wellman',
  [DfwCities.Wells]: 'Wells',
  [DfwCities.Wellsboro]: 'Wellsboro',
  [DfwCities.Weslaco]: 'Weslaco',
  [DfwCities.West]: 'West',
  [DfwCities.WestColumbia]: 'West Columbia',
  [DfwCities.WestFargo]: 'West Fargo',
  [DfwCities.WestLakeHills]: 'West Lake Hills',
  [DfwCities.WestOrange]: 'West Orange',
  [DfwCities.WestTawakoni]: 'West Tawakoni',
  [DfwCities.WestUniversityPlace]: 'West University Place',
  [DfwCities.Westbrook]: 'Westbrook',
  [DfwCities.Westlake]: 'Westlake',
  [DfwCities.Westminster]: 'Westminster',
  [DfwCities.Weston]: 'Weston',
  [DfwCities.WestoverHills]: 'Westover Hills',
  [DfwCities.WestworthVillage]: 'Westworth Village',
  [DfwCities.Wharton]: 'Wharton',
  [DfwCities.Wheeler]: 'Wheeler',
  [DfwCities.Wheelock]: 'Wheelock',
  [DfwCities.WhiteDeer]: 'White Deer',
  [DfwCities.WhiteOak]: 'White Oak',
  [DfwCities.WhiteSettlement]: 'White Settlement',
  [DfwCities.Whiteface]: 'Whiteface',
  [DfwCities.Whitehouse]: 'Whitehouse',
  [DfwCities.Whitesboro]: 'Whitesboro',
  [DfwCities.Whitewright]: 'Whitewright',
  [DfwCities.Whitman]: 'Whitman',
  [DfwCities.Whitney]: 'Whitney',
  [DfwCities.Whitsett]: 'Whitsett',
  [DfwCities.Whitt]: 'Whitt',
  [DfwCities.WichitaFalls]: 'Wichita Falls',
  [DfwCities.Wickett]: 'Wickett',
  [DfwCities.Wilburton]: 'Wilburton',
  [DfwCities.Williamstown]: 'Williamstown',
  [DfwCities.Willis]: 'Willis',
  [DfwCities.WillowCity]: 'Willow City',
  [DfwCities.WillowPark]: 'Willow Park',
  [DfwCities.WillsPoint]: 'Wills Point',
  [DfwCities.Wilmer]: 'Wilmer',
  [DfwCities.Wilson]: 'Wilson',
  [DfwCities.Wimberley]: 'Wimberley',
  [DfwCities.Winchell]: 'Winchell',
  [DfwCities.Windcrest]: 'Windcrest',
  [DfwCities.Windom]: 'Windom',
  [DfwCities.Windthorst]: 'Windthorst',
  [DfwCities.Winfield]: 'Winfield',
  [DfwCities.Wingate]: 'Wingate',
  [DfwCities.Wink]: 'Wink',
  [DfwCities.Winnsboro]: 'Winnsboro',
  [DfwCities.Winona]: 'Winona',
  [DfwCities.WinterHaven]: 'Winter Haven',
  [DfwCities.WinterPark]: 'Winter Park',
  [DfwCities.Winters]: 'Winters',
  [DfwCities.Wister]: 'Wister',
  [DfwCities.WixonValley]: 'Wixon Valley',
  [DfwCities.Woden]: 'Woden',
  [DfwCities.WolfeCity]: 'Wolfe City',
  [DfwCities.Woodbranch]: 'Woodbranch',
  [DfwCities.Woodcreek]: 'Woodcreek',
  [DfwCities.WoodlandPark]: 'Woodland Park',
  [DfwCities.Woodlawn]: 'Woodlawn',
  [DfwCities.Woodloch]: 'Woodloch',
  [DfwCities.Woodsboro]: 'Woodsboro',
  [DfwCities.Woodson]: 'Woodson',
  [DfwCities.Woodville]: 'Woodville',
  [DfwCities.Woodway]: 'Woodway',
  [DfwCities.Wortham]: 'Wortham',
  [DfwCities.WrightCity]: 'Wright City',
  [DfwCities.Wylie]: 'Wylie',
  [DfwCities.Wynnewood]: 'Wynnewood',
  [DfwCities.Yancey]: 'Yancey',
  [DfwCities.Yantis]: 'Yantis',
  [DfwCities.Yellville]: 'Yellville',
  [DfwCities.Yoakum]: 'Yoakum',
  [DfwCities.York]: 'York',
  [DfwCities.Yreka]: 'Yreka',
  [DfwCities.Yuba]: 'Yuba',
  [DfwCities.Zapata]: 'Zapata',
  [DfwCities.Zavalla]: 'Zavalla',
  [DfwCities.Zephyr]: 'Zephyr',
  [DfwCities.Zirahuen]: 'Zirahuen',
  [DfwCities.NotApplicable]: 'NotApplicable',
  [DfwCities.PrairieRidge]: 'Prairie Ridge'
};
